<template>
    <div :style="{'height': config && config.adjustContent ? '100%' : ''}">
        <div id="user-login" style="display: none;"></div>
        <div id="success-view" style="display: none;"></div>
        <div id="link-view" style="display: none;"></div>
        <div v-if="apiFailed" class="app-error-info">
            <img src="../assets/images/icon_server_down.svg" />
            <div>
                Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.
            </div>
        </div>
        <div
            v-if="str"
            v-show="initialized"
            class="app-container"
            :style="[{'background-color': config.backgroundImage ? 'transparent' : config.backgroundColor, 'color': config.textColor, 'height': config.adjustContent ? '100%' : ''}, config.screenStyles]"
            :class="[config.font ? ('app-container-font-' + config.font) : '']"
        >
            <div v-if="isProcessing">
                <div
                    class="app-processing"
                >
                    {{ str['processing'] }}
                </div>
            </div>
            <div
                v-if="!isProcessing"
                v-for="(step, currentIndex) in config.steps"
                :key="currentIndex"
                :class="[stepIndex === currentIndex && step.id === 'background_image' ? 'app-container-step-background' : '', config.adjustContent && stepIndex === currentIndex ? 'app-container-adjust-content' : '']"
                :style="[{'backgroundImage': step.id === 'background_image' ? 'url(' + step.backgroundImage + ')' : ''}, step.screenContainerStyles]"
            >
                <div
                    v-if="stepIndex === currentIndex"
                    class="app-content"
                    :style="step.screenStyles"
                >
                    <div v-if="currentIndex < config.steps.length - 1 && !step.finishStep && !step.hideBackButton && config.backTop">
                        <div
                            @click="backStep()"
                            class="app-button-top-back"
                            :style="config.backTop.styles"
                        >
                            <i
                                class="fa fa-chevron-left"
                                :style="{'color': config.backTop.iconColor}"
                            ></i>
                            <span :style="{'color': config.backTop.textColor}">
                                {{ str['back'] }}
                            </span>
                        </div>
                    </div>
                    <!-- Title -->
                    <div
                        v-if="getStepProperty(step, 'title')"
                        class="app-title text-bold"
                        v-html="getStepProperty(step, 'title')"
                        :style="config.titleStyles"
                    ></div>
                    <!-- Subtitle -->
                    <div
                        v-if="getStepProperty(step, 'subtitle')"
                        class="app-subtitle text-bold"
                        v-html="getStepProperty(step, 'subtitle')"
                        :style="config.subtitleStyles"
                    ></div>
                    <!-- Image -->
                    <div
                        v-if="getStepProperty(step, 'image')"
                        class="app-image"
                    >
                        <img :src="getStepProperty(step, 'image')" :style="{width: step.imageSize}" />
                    </div>
                    <div
                        v-if="getStepProperty(step, 'buttonLink')"
                        class="app-button-link"
                    >
                        <v-btn
                            @click="openLinkUrl(getStepProperty(step, 'buttonLink').url)"
                            class="app-button-next"
                            :style="{color: getStepProperty(step, 'buttonLink').textColor, backgroundColor: getStepProperty(step, 'buttonLink').backgroundColor, height: getStepProperty(step, 'buttonLink').height}"
                        >
                            {{ str[getStepProperty(step, 'buttonLink').text] ? str[getStepProperty(step, 'buttonLink').text] : getStepProperty(step, 'buttonLink').text }}
                        </v-btn>
                    </div>
                    <!-- Video -->
                    <div v-if="step.video" class="app-video">
                        <iframe
                            v-if="!step.local"
                            width="100%"
                            :height="step.videoSize ? step.videoSize : 300"
                            :src="step.video"
                            frameborder="0"
                        ></iframe>
                        <video
                            v-if="step.local"
                            :id="step.id + '-video-element'"
                            :src="step.video"
                            style="background-color: #000; width: 100%;"
                            :style="{'height': step.height ? step.height : videoHeight}"
                            controls
                        ></video>
                    </div>
                    <!-- Info -->
                    <div
                        v-if="getStepProperty(step, 'info')"
                        class="app-info"
                        v-html="getStepProperty(step, 'info')"
                        :style="[config.infoStyles, step.infoStyles]"
                    ></div>
                    <!-- Info -->
                    <div
                        v-if="getStepProperty(step, 'clipboard')"
                        class="app-clipboard"
                        :style="[config.clipboardStyles, step.clipboardStyles]"
                    >
                        <div
                            v-for="clipboardText in getStepProperty(step, 'clipboard')"
                            @click="copyTextToClipboard($event, str[clipboardText.text] ? str[clipboardText.text] : clipboardText.text)"
                        >
                            <b v-if="clipboardText.title">
                                {{ str[clipboardText.title] ? str[clipboardText.title] : clipboardText.title }}:
                            </b>
                            <span>
                                {{ str[clipboardText.text] ? str[clipboardText.text] : clipboardText.text }}
                            </span>
                            <span class="app-clipboard-icon">
                                <i class="fa fa-clone" />
                            </span>
                        </div>
                    </div>
                    <!-- Images carousel -->
                    <div v-if="step.images" class="app-margin-space">
                        <v-carousel
                            :continuous="false"
                            :cycle="false"
                            hide-delimiters
                            style="box-shadow: none; outline: none; height: 200px;"
                        >
                            <v-carousel-item
                                v-for="(img, index) in step.images"
                                :key="index"
                            >
                                <v-sheet
                                    height="200px"
                                    style="text-align: center; background-color: transparent;"
                                >
                                    <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                        <img
                                            :src="img"
                                            style="max-width: 200px; max-height: 200px;"
                                        />
                                    </div>
                                </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </div>
                    <div v-if="step.promotionalCodeButton" class="app-margin-space app-button-element">
                        <v-btn
                            color="default"
                            @click="applyPromotionalCode()"
                        >
                            {{ str['apply_promotional_code'] }}
                        </v-btn>
                    </div>
                    <!-- Body -->
                    <div class="app-body">
                        <!-- Fields - no subscription form -->
                        <div
                            v-if="step.fields && step.id !== 'subscription'"
                            class="app-body-div-container"
                        >
                            <div
                                v-for="item in step.fields"
                                :key="item.id"
                                class="form-row"
                                v-show="checkItemCondition(step.fields, item)"
                                :class="{'form-row-label': item.type === 'label'}"
                            >
                                <span
                                    v-if="item.parent && !item.hideParent"
                                    class="form-row-title-parent"
                                >
                                    {{ item.parent }}
                                </span>
                                <span
                                    v-if="!item.hideTitle && !item.htmlTitle && !item.outlineDisabled"
                                    class="form-row-title"
                                    :style="[config.fieldTitleStyles, item.titleStyles]"
                                >
                                    {{ item.title }}
                                    <span
                                        v-if="item.icon_info"
                                        style="padding: 0 10px;"
                                        @click="showInfo(item.icon_info)"
                                    >
                                        <i
                                            class="fa fa-info-circle"
                                            style="font-size: 20px;"
                                        />
                                    </span>
                                </span>
                                <span
                                    v-if="item.htmlTitle"
                                    class="form-row-title"
                                    :style="item.titleStyles"
                                    v-html="item.htmlTitle"
                                ></span>
                                <span
                                    v-if="item.showLabelSelected"
                                    class="app-label-selected"
                                    :style="config.labelSelectedStyles"
                                >
                                    {{ getFieldItem(item).label }}
                                </span>
                                <span
                                    v-if="item.showLabelImageSelected"
                                    class="app-label-image-selected"
                                >
                                    <img
                                        :src="getFieldItem(item).labelImage"
                                    />
                                </span>
                                <div
                                    v-if="item.indicative"
                                    class="form-row-mobile-phone-indicative"
                                    @click="openSelectIndicativeSearch(item)"
                                >
                                    <v-select
                                        v-model="mobilePhoneIndicative"
                                        item-text="label"
                                        item-value="value"
                                        :items="mobilePhonePrefixsList"
                                        :no-data-text="str['no_data']"
                                        hide-details
                                        :label="item.outlineDisabled ? item.title : null"
                                        :outline="!item.outlineDisabled ? true : false"
                                        style="pointer-events: none;"
                                        append-icon="fa-caret-down"
                                    >
                                    </v-select>
                                    <v-dialog
                                        ref="dialog"
                                        v-model="item.opened"
                                        max-width="300"
                                        persistent
                                    >
                                        <v-card>
                                            <v-card-text
                                                class="pt-2 pb-0"
                                            >
                                                <v-text-field
                                                    v-model="selectSearchItemsSearch"
                                                    append-icon="mdi-magnify"
                                                    :label="str['search']"
                                                    single-line
                                                    hide-details
                                                    class="select-search-list-search pt-0 mt-0 mb-3"
                                                    clearable
                                                />
                                                <div
                                                    class="select-search-list select-search-list-center"
                                                >
                                                    <div
                                                        v-for="mItem in selectSearchItems"
                                                        class="checkbox-container"
                                                        @click="selectItemSelectIndicativeSearch(item, mItem)"
                                                        v-show="!selectSearchItemsSearch || mItem.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(selectSearchItemsSearch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()) > -1"
                                                        :class="{'active': mItem.active}"
                                                    >
                                                        <div>
                                                            {{ mItem.label }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                            <v-card-actions
                                                class="pt-3 pb-3"
                                                style="justify-content: center;"
                                            >
                                                <v-btn
                                                    color="default"
                                                    @click="closeSelectSearch(item)"
                                                >
                                                    {{ str['ok'] }}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>
                                <v-text-field
                                    v-if="item.type == 'input' && !item.isPassword && item.inputType != 'numeric' && item.inputType != 'integer'"
                                    v-model="item.value"
                                    :disabled="item.disabled ? true : false"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    rounded
                                    clearable
                                    :maxlength="item.maxLength ? item.maxLength : null"
                                    @input="onChangeInput(item)"
                                    :class="[{'form-row-mobile-phone-number': item.indicative}, config.inputStyles]"
                                />
                                <v-text-field
                                    v-if="item.type == 'input_mask'"
                                    v-model="item.value"
                                    :disabled="item.disabled ? true : false"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    rounded
                                    clearable
                                    return-masked-value
                                    :mask="item.mask"
                                    :class="config.inputStyles"
                                />
                                <v-text-field
                                    v-if="item.type == 'input' && !item.isPassword && item.inputType == 'numeric'"
                                    v-model="item.value"
                                    :disabled="item.disabled ? true : false"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    rounded
                                    clearable
                                    oninput="this.value = this.value.replace(/[^0-9.,]/g, '').replace(/([.,].*)[.,]/g, '$1');"
                                    :maxlength="item.maxLength ? item.maxLength : null"
                                    :class="[{'form-row-mobile-phone-number': item.indicative}, config.inputStyles]"
                                />
                                <v-text-field
                                    v-if="item.type == 'input' && !item.isPassword && item.inputType == 'integer'"
                                    v-model="item.value"
                                    :disabled="item.disabled ? true : false"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    rounded
                                    clearable
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                    :maxlength="item.maxLength ? item.maxLength : null"
                                    :class="[{'form-row-mobile-phone-number': item.indicative}, config.inputStyles]"
                                />
                                <v-text-field
                                    v-if="item.type == 'input' && item.isPassword"
                                    v-model="item.value"
                                    :disabled="item.disabled ? true : false"
                                    :type="visiblePasswords.indexOf(item.id) > -1 ? 'text' : 'password'"
                                    class="form-row-input-password"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    rounded
                                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@\-_]/g, '');"
                                    :class="config.inputStyles"
                                />
                                <span
                                    v-show="item.type == 'input' && item.isPassword && !item.hideEye && visiblePasswords.indexOf(item.id) > -1"
                                    class="form-row-password-icon"
                                    @click="showPassword(item)"
                                >
                                    <i class="fa fa-eye" />
                                </span>
                                <span
                                    v-show="item.type == 'input' && item.isPassword && !item.hideEye && visiblePasswords.indexOf(item.id) < 0"
                                    class="form-row-password-icon"
                                    @click="showPassword(item)"
                                >
                                    <i class="fa fa-eye-slash" />
                                </span>
                                <v-select
                                    v-if="item.type == 'select'"
                                    v-model="item.value"
                                    item-text="label"
                                    item-value="value"
                                    :items="item.items"
                                    :no-data-text="str['no_data']"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    @change="onChangeSelect(item)"
                                    append-icon="fa-caret-down"
                                />
                                <v-autocomplete
                                    v-if="item.type == 'select_search'"
                                    v-model="item.value"
                                    item-text="label"
                                    item-value="value"
                                    :items="item.items"
                                    :no-data-text="str['no_data']"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    @change="onChangeSelect(item)"
                                    append-icon="fa-caret-down"
                                />
                                <div
                                    v-if="item.type == 'select_search_dialog'"
                                    class="select-search"
                                    @click="openSelectSearch(item)"
                                >
                                    <v-select
                                        :ref="'component-multiselect-' + item.id"
                                        v-model="item.value"
                                        item-text="label"
                                        item-value="value"
                                        :items="item.items"
                                        :no-data-text="str['no_data']"
                                        hide-details
                                        :label="item.outlineDisabled ? item.title : null"
                                        :outline="!item.outlineDisabled ? true : false"
                                        style="pointer-events: none;"
                                        append-icon="fa-caret-down"
                                    >
                                    </v-select>
                                    <v-dialog
                                        ref="dialog"
                                        v-model="item.opened"
                                        width="95%"
                                        max-width="500"
                                        persistent
                                    >
                                        <v-card>
                                            <v-card-text
                                                class="pt-2 pb-0"
                                            >
                                                <v-text-field
                                                    v-model="selectSearchItemsSearch"
                                                    append-icon="mdi-magnify"
                                                    :label="str['search']"
                                                    single-line
                                                    hide-details
                                                    class="select-search-list-search pt-0 mt-0 mb-3"
                                                    clearable
                                                />
                                                <div
                                                    class="select-search-list"
                                                >
                                                    <div
                                                        v-for="mItem in selectSearchItems"
                                                        class="checkbox-container"
                                                        @click="selectItemSelectSearch(item, mItem)"
                                                        v-show="!selectSearchItemsSearch || mItem.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(selectSearchItemsSearch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()) > -1"
                                                        :class="{'active': mItem.active}"
                                                    >
                                                        <div>
                                                            {{ mItem.label }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                            <v-card-actions
                                                class="pt-3 pb-3"
                                                style="justify-content: center;"
                                            >
                                                <v-btn
                                                    color="default"
                                                    @click="closeSelectSearch(item)"
                                                >
                                                    {{ str['ok'] }}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>
                                <tags-input
                                    v-if="item.type == 'tags'"
                                    v-model="item.value"
                                    :existing-tags="item.items"
                                    id-field="value"
                                    text-field="label"
                                    :placeholder="item.placeholder ? str[item.placeholder] : ''"
                                    delete-on-backspace
                                    only-existing-tags
                                    typeahead
                                    :typeahead-max-results="3"
                                    typeahead-hide-discard
                                />
                                <v-select
                                    v-if="item.type == 'multiselect'"
                                    :ref="'component-multiselect-' + item.id"
                                    v-model="item.value"
                                    item-text="label"
                                    item-value="value"
                                    :items="item.items"
                                    :no-data-text="str['no_data']"
                                    hide-details
                                    :label="item.outlineDisabled ? item.title : null"
                                    :outline="!item.outlineDisabled ? true : false"
                                    multiple
                                    chips
                                    small-chips
                                    append-icon="fa-caret-down"
                                >
                                    <template v-slot:prepend-item>
                                        <div
                                            @click="closeSelect(item.id)"
                                            class="component-select-close"
                                        >
                                            {{ str['ok'] }}
                                        </div>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                </v-select>
                                <div
                                    v-if="item.type == 'multiselect_search'"
                                    class="multiselect-search"
                                    @click="openSelectSearch(item)"
                                >
                                    <v-select
                                        :ref="'component-multiselect-' + item.id"
                                        v-model="item.value"
                                        item-text="label"
                                        item-value="value"
                                        :items="item.items"
                                        :no-data-text="str['no_data']"
                                        hide-details
                                        :label="item.outlineDisabled ? item.title : null"
                                        :outline="!item.outlineDisabled ? true : false"
                                        multiple
                                        chips
                                        small-chips
                                        style="pointer-events: none;"
                                        append-icon="fa-caret-down"
                                    >
                                    </v-select>
                                    <v-dialog
                                        ref="dialog"
                                        v-model="item.opened"
                                        width="95%"
                                        max-width="500"
                                        persistent
                                    >
                                        <v-card>
                                            <v-card-text
                                                class="pt-2 pb-0"
                                            >
                                                <v-text-field
                                                    v-model="selectSearchItemsSearch"
                                                    append-icon="mdi-magnify"
                                                    :label="str['search']"
                                                    single-line
                                                    hide-details
                                                    class="select-search-list-search pt-0 mt-0 mb-3"
                                                    clearable
                                                />
                                                <div
                                                    class="select-search-list"
                                                >
                                                    <div
                                                        v-for="mItem in selectSearchItems"
                                                        class="checkbox-container"
                                                        :class="{'disabled': mItem.disabled}"
                                                        @click="selectItemSelectSearch(item, mItem)"
                                                        v-show="!selectSearchItemsSearch || mItem.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(selectSearchItemsSearch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()) > -1"
                                                    >
                                                        <div
                                                            class="checkbox-container-box"
                                                            :style="{'border-color': '#888', 'color': '#4caf50'}"
                                                        >
                                                            <div v-if="mItem.active">
                                                                <i class="fa fa-check"></i>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {{ mItem.label }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                            <v-card-actions
                                                class="pt-3 pb-3"
                                                style="justify-content: center;"
                                            >
                                                <v-btn
                                                    color="default"
                                                    @click="closeSelectSearch(item)"
                                                >
                                                    {{ str['cancel'] }}
                                                </v-btn>
                                                <v-btn
                                                    color="success"
                                                    @click="confirmSelectSearch(item)"
                                                >
                                                    {{ str['confirm'] }}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>
                                <v-radio-group
                                    v-if="item.type == 'radio_button'"
                                    v-model="item.value"
                                    hide-details
                                    outline
                                >
                                    <v-radio
                                        v-for="radioButtonItem, radioButtonIndex in item.items"
                                        :key="radioButtonIndex"
                                        :label="radioButtonItem.label"
                                        :value="radioButtonItem.value"
                                    ></v-radio>
                                </v-radio-group>
                                <div v-if="item.type == 'datepicker'">
                                    <v-dialog
                                        ref="dialog"
                                        v-model="datepicker"
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="item.value"
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details
                                                outline
                                                rounded
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-if="item.id == 'birth_date' && !item.value"
                                            v-model="defaultBirthDate"
                                            :max="item.id == 'birth_date' ? currentDate: null"
                                            style="margin: 0;"
                                            @change="changeDatepicker"
                                            :locale="datepickerLanguage"
                                            no-title
                                        >
                                        </v-date-picker>
                                        <v-date-picker
                                            v-if="item.id != 'birth_date' || (item.id == 'birth_date' && item.value)"
                                            v-model="item.value"
                                            :max="item.id == 'birth_date' ? currentDate: null"
                                            style="margin: 0;"
                                            @change="changeDatepicker"
                                            :locale="datepickerLanguage"
                                            no-title
                                        >
                                        </v-date-picker>
                                    </v-dialog>
                                </div>
                                <div
                                    v-if="item.type == 'datepicker_inline'"
                                    class="form-row-datepicker-inline"
                                >
                                    <scroll-picker
                                        :options="getDays()"
                                        v-model="datepickerInline.day"
                                        @input="changeDatepickerInline(item)"
                                    ></scroll-picker>
                                    <scroll-picker
                                        :options="getMonths()"
                                        v-model="datepickerInline.month"
                                        @input="changeDatepickerInline(item)"
                                    ></scroll-picker>
                                    <scroll-picker
                                        :options="getYears()"
                                        v-model="datepickerInline.year"
                                        @input="changeDatepickerInline(item)"
                                    ></scroll-picker>
                                </div>
                                <div v-if="item.type == 'timepicker'">
                                    <v-dialog
                                        ref="dialog"
                                        v-model="timepicker[item.id]"
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="item.value"
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details
                                                outline
                                                rounded
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="timepicker[item.id]"
                                            v-model="item.value"
                                            format="24hr"
                                            @change="changeTimepicker($event, item)"
                                            :locale="datepickerLanguage"
                                            no-title
                                        ></v-time-picker>
                                    </v-dialog>
                                </div>
                                <v-textarea
                                    v-if="item.type == 'textarea'"
                                    v-model="item.value"
                                    autocomplete="new-password"
                                    :name="Math.random()"
                                    :placeholder="item.placeholder"
                                    hide-details
                                    outlined
                                    rounded
                                    :class="[config.inputStyles, item.large ? 'form-row-field-textarea-large' : null]"
                                ></v-textarea>
                                <div
                                    v-if="item.type == 'buttons'"
                                    class="form-row-field-buttons"
                                >
                                    <div
                                        v-for="buttonOpt in item.items"
                                    >
                                        <div
                                            @click="selectButtonOption(item, buttonOpt.value)"
                                            class="form-row-field-button"
                                            :class="{'form-row-field-button-active': item.value === buttonOpt.value}"
                                            :style="{backgroundImage: item.buttonBackground ? 'url(' + item.buttonBackground + ')' : ''}"
                                        >
                                            <img
                                                v-if="buttonOpt.image"
                                                :src="buttonOpt.image"
                                            />
                                            <div
                                                v-if="!buttonOpt.image && buttonOpt.label"
                                                v-html="str[buttonOpt.label] ? str[buttonOpt.label] : buttonOpt.label"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="item.type == 'slider_horizontal'"
                                    class="form-row-field-slider-horizontal"
                                >
                                    <vueper-slides
                                        class="no-shadow"
                                        :visible-slides="3"
                                        :gap="3"
                                        :bullets="false"
                                        @slide="changeSlide(item, $event)"
                                        :init-slide="item.initSlide"
                                    >
                                        <vueper-slide
                                            v-for="(buttonOpt, buttonOptIndex) in item.items"
                                            :key="buttonOptIndex"
                                        >
                                            <template #content>
                                                <div
                                                    class="form-row-field-button form-row-field-button-slider"
                                                    :class="{'form-row-field-button-active': item.value === buttonOpt.value}"
                                                    :style="{backgroundImage: item.buttonBackground ? 'url(' + item.buttonBackground + ')' : ''}"
                                                >
                                                    <img
                                                        v-if="buttonOpt.image"
                                                        :src="buttonOpt.image"
                                                    />
                                                    <div
                                                        v-if="!buttonOpt.image && buttonOpt.label"
                                                        v-html="str[buttonOpt.label] ? str[buttonOpt.label] : buttonOpt.label"
                                                    ></div>
                                                </div>
                                            </template>
                                        </vueper-slide>
                                    </vueper-slides>
                                </div>
                            </div>
                        </div>
                        <!-- Add photos -->
                        <div v-if="step.id === 'photos'" class="app-margin-space">
                            <div v-for="(photo, index) in step.photos" :key="index">
                                <div v-if="step.photosCaptions && step.photosCaptions[index]" class="form-row-photo-caption">
                                    {{ str[step.photosCaptions[index]] ? str[step.photosCaptions[index]] : step.photosCaptions[index] }}
                                </div>
                                <photo :callback="receivePhoto" :argument="index" :photo="photo" />
                            </div>
                        </div>
                        <!-- Add videos -->
                        <div v-if="step.id === 'videos'" class="app-margin-space">
                            <div v-for="(video, index) in step.videos" :key="index">
                                <video-element :callback="receiveVideo" :argument="index" :video="video" />
                            </div>
                        </div>
                        <!-- Add proof -->
                        <div v-if="step.id === 'proof'" class="app-margin-space">
                            <div v-for="(photo, index) in step.photos" :key="index">
                                <photo :callback="receivePhoto" :argument="index" :photo="photo" :size="1024" />
                            </div>
                        </div>
                        <!-- Select plan -->
                        <div v-if="step.id === 'plans'" class="app-margin-space">
                            <v-carousel
                                v-if="step.type !== 'buttons' && step.type !== 'cards'"
                                :continuous="false"
                                :cycle="false"
                                :value="step.slideIndex"
                                hide-delimiters
                                style="box-shadow: none; outline: none;"
                            >
                                <v-carousel-item
                                    v-for="(slide, index) in step.slide"
                                    :key="index"
                                >
                                    <v-sheet
                                        height="100%"
                                        style="text-align: center; background-color: transparent;"
                                    >
                                        <img
                                            @click="selectPlan(step, slide)"
                                            :src="slide.image"
                                            style="max-height: 100%; max-width: 100%;"
                                        />
                                    </v-sheet>
                                </v-carousel-item>
                            </v-carousel>
                            <div
                                v-if="step.type === 'buttons'"
                                class="app-buttons-cols"
                                :class="{'app-buttons-flex': !step.slide[0].buttonBackground, 'app-buttons-flex-buttons-background': step.slide[0].buttonBackground}"
                            >
                                <div 
                                    v-for="(slide, slideIndex) in step.slide"
                                    :key="slideIndex"
                                    class="app-buttons-cols-item"
                                >
                                    <div
                                        @click="selectPlan(step, slide)"
                                        :style="{color: slide.textColor, backgroundColor: slide.backgroundColor, backgroundImage: slide.buttonBackground ? 'url(' + slide.buttonBackground + ')' : ''}"
                                        :class="{'v-btn': !slide.buttonBackground, 'form-row-field-button': slide.buttonBackground}"
                                        v-html="slide.html"
                                    ></div>
                                </div>
                            </div>
                            <div
                                v-if="step.type === 'cards'"
                                class="app-cards"
                            >
                                <div 
                                    v-for="(slide, slideIndex) in step.slide"
                                    :key="slideIndex"
                                    class="app-cards-item"
                                >
                                    <div :style="{color: slide.textColor, backgroundColor: slide.backgroundColor, backgroundImage: slide.buttonBackground ? 'url(' + slide.buttonBackground + ')' : ''}">
                                        <div v-html="slide.translate ? slide.html[language] : slide.html"></div>
                                        <div class="card-button">
                                            <v-btn
                                                @click="selectPlan(step, slide)"
                                                :style="{color: slide.buttonTextColor, backgroundColor: slide.buttonBackgroundColor}"
                                            >
                                                {{ str['select_plan'] }}
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Subscription form -->
                        <div
                            v-if="step.id === 'subscription'"
                            class="app-subscription-container"
                        >
                            <stripe-subscription
                                ref="stripeRef"
                                :step="step"
                                :terms="step.terms"
                                :gdpr="step.gdpr"
                            />
                        </div>
                        <!-- Select currency -->
                        <div v-if="step.id === 'currency'" class="app-buttons-flex">
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="nextStep({valueSelected: buttonElement.id})"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn"
                            >
                                {{ buttonElement.text }}
                            </div>
                        </div>
                        <!-- Select and go to specific step -->
                        <div
                            v-if="step.goToStep"
                            :class="{'app-buttons-flex': !step.buttons[0].buttonBackground, 'app-buttons-flex-buttons-background': step.buttons[0].buttonBackground}"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="nextStep({nextStepId: buttonElement.step, proofDescription: buttonElement.proofDescription})"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor, backgroundImage: buttonElement.buttonBackground ? 'url(' + buttonElement.buttonBackground + ')' : ''}"
                                :class="{'v-btn': !buttonElement.buttonBackground, 'form-row-field-button': buttonElement.buttonBackground}"
                            >
                                {{ buttonElement.text }}
                            </div>
                        </div>
                        <!-- Select hotmart plan -->
                        <div
                            v-if="step.id === 'hotmart_plans' && !step.boxs"
                            class="app-buttons-flex app-buttons-flex-small"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="selectHotmartPlan(buttonElement)"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn"
                            >
                                {{ buttonElement.text }}{{ buttonElement.textInfo ? (' ' + buttonElement.textInfo) : '' }}
                            </div>
                        </div>
                        <div
                            v-if="step.id === 'hotmart_plans' && step.boxs"
                            class="app-buttons-cols"
                            :class="{'app-buttons-flex': !step.buttons[0].buttonBackground, 'app-buttons-flex-buttons-background': step.buttons[0].buttonBackground}"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                class="app-buttons-cols-item"
                            >
                                <div
                                    @click="selectHotmartPlan(buttonElement)"
                                    :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor, backgroundImage: buttonElement.buttonBackground ? 'url(' + buttonElement.buttonBackground + ')' : ''}"
                                    :class="{'v-btn': !buttonElement.buttonBackground, 'form-row-field-button': buttonElement.buttonBackground}"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                        </div>
                        <!-- Select stripe plan -->
                        <div
                            v-if="step.id === 'stripe_plans' && !step.boxs"
                            class="app-buttons-flex app-buttons-flex-small"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="selectStripePlan(buttonElement)"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn"
                                v-html="buttonElement.text"
                            ></div>
                        </div>
                        <div
                            v-if="step.id === 'stripe_plans' && step.boxs"
                            class="app-buttons-cols"
                            :class="{'app-buttons-flex': !step.buttons[0].buttonBackground, 'app-buttons-flex-buttons-background': step.buttons[0].buttonBackground}"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                class="app-buttons-cols-item"
                            >
                                <div
                                    @click="selectStripePlan(buttonElement)"
                                    :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor, backgroundImage: buttonElement.buttonBackground ? 'url(' + buttonElement.buttonBackground + ')' : ''}"
                                    :class="{'v-btn': !buttonElement.buttonBackground, 'form-row-field-button': buttonElement.buttonBackground}"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                        </div>
                        <!-- Select viva wallet plan -->
                        <div
                            v-if="(step.id === 'viva_wallet_plans' || step.id === 'viva_wallet_subscription_plans') && !step.boxs"
                            class="app-buttons-flex app-buttons-flex-small"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="selectVivaWalletPlan(buttonElement)"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn app-button-card"
                            >
                                <div v-html="buttonElement.text"></div>
                                <div
                                    v-if="buttonElement.info"
                                    v-html="buttonElement.info"
                                ></div>
                            </div>
                        </div>
                        <div
                            v-if="(step.id === 'viva_wallet_plans' || step.id === 'viva_wallet_subscription_plans') && step.boxs"
                            class="app-buttons-cols"
                            :class="{'app-buttons-flex': !step.buttons[0].buttonBackground, 'app-buttons-flex-buttons-background': step.buttons[0].buttonBackground}"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                class="app-buttons-cols-item"
                            >
                                <div
                                    @click="selectVivaWalletPlan(buttonElement)"
                                    :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor, backgroundImage: buttonElement.buttonBackground ? 'url(' + buttonElement.buttonBackground + ')' : ''}"
                                    :class="{'v-btn': !buttonElement.buttonBackground, 'form-row-field-button': buttonElement.buttonBackground}"
                                    v-html="buttonElement.text"
                                ></div>
                            </div>
                        </div>
                        <div
                            v-if="step.id === 'payments_packs_categories'"
                            class="app-buttons-flex app-buttons-flex-small"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="selectVivaWalletPackCategory(buttonElement)"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn app-button-card"
                            >
                                <div v-html="buttonElement.text"></div>
                                <div
                                    v-if="buttonElement.info"
                                    v-html="buttonElement.info"
                                ></div>
                            </div>
                        </div>
                        <div
                            v-if="step.id === 'payments_packs_category'"
                            class="app-buttons-flex app-buttons-flex-small"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="selectVivaWalletPack(buttonElement)"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn app-button-card"
                            >
                                <div v-html="buttonElement.text"></div>
                                <div
                                    v-if="buttonElement.info"
                                    v-html="buttonElement.info"
                                ></div>
                            </div>
                        </div>
                        <div
                            v-if="step.id === 'payments_pack'"
                            class="app-buttons-flex app-buttons-flex-small"
                        >
                            <div 
                                v-for="(buttonElement, buttonIndex) in step.buttons"
                                :key="buttonIndex"
                                @click="selectVivaWalletPackMode(buttonElement)"
                                :style="{color: buttonElement.textColor, backgroundColor: buttonElement.backgroundColor}"
                                class="v-btn app-button-card"
                            >
                                <div v-html="buttonElement.text"></div>
                                <div
                                    v-if="buttonElement.info"
                                    v-html="buttonElement.info"
                                ></div>
                            </div>
                        </div>
                        <!-- Html content -->
                        <div
                            v-if="step.tabs"
                            class="app-step-tabs"
                        >
                            <div
                                v-for="stepTab in step.tabs.items"
                                @click="step.id = stepTab.value"
                                :style="{
                                    'color': step.id === stepTab.value ? step.tabs.active.color : step.tabs.default.color,
                                    'background-color': step.id === stepTab.value ? step.tabs.active.backgroundColor : step.tabs.default.backgroundColor
                                }"
                            >
                                <div :style="{'border-color': step.id === stepTab.value ? step.tabs.active.borderColor : step.tabs.default.borderColor}">
                                    {{ stepTab.label }}
                                </div>
                            </div>
                        </div>
                        <div v-if="step.type === 'html'">
                            <div v-html="config[step.id]"></div>
                            <div v-if="step.check_text"
                                class="checkbox-container"
                                style="margin-top: 10px"
                            >
                                <div @click="changeTermsValue()"
                                    class="checkbox-container-box"
                                    :style="{'border-color': config.textColor, 'color': config.textColor}"
                                >
                                    <div v-if="termsValue">
                                        <i class="fa fa-check"></i>
                                    </div>
                                </div>
                                <div @click="changeTermsValue()">
                                    {{ str[step.check_text] ? str[step.check_text] : step.check_text }}
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="step.checkbox"
                            class="row stripe-terms-checkbox"
                            style="margin-top: 0; margin-bottom: 20px;"
                        >
                            <div class="checkbox-container">
                                <div @click="step.checkbox.value = !step.checkbox.value"
                                    class="checkbox-container-box"
                                    :style="{'border-color': config.textColor, 'color': config.textColor}"
                                >
                                    <div v-if="step.checkbox.value">
                                        <i class="fa fa-check"></i>
                                    </div>
                                </div>
                                <div @click="step.checkbox.value = !step.checkbox.value">
                                    {{ str[step.checkbox.text] ? str[step.checkbox.text] : step.checkbox.text }}
                                </div>
                            </div>
                            <a
                                v-if="step.checkbox.url"
                                @click.stop="openLinkUrl(step.checkbox.url)"
                                class="nav-link"
                            >
                                {{ str[step.checkbox.linkText] ? str[step.checkbox.linkText] : step.checkbox.linkText }}
                            </a>
                        </div>
                        <!-- Webview content -->
                        <div v-if="step.type === 'webview' && !step.webviewFullSize" style="margin-top: 10px;">
                            <iframe
                                v-if="step.url"
                                :src="step.url"
                                style="width: 100%; height: calc(100vh - 150px);"
                            />
                        </div>
                        <div v-if="step.type === 'webview' && step.webviewFullSize" style="margin-top: 10px;">
                            <iframe
                                v-if="step.url"
                                :src="step.url"
                                style="width: 100%; height: calc(100vh - 100px);"
                            />
                        </div>
                    </div>
                    <div
                        v-if="getStepProperty(step, 'footerMessage')"
                        class="app-footer-message"
                        v-html="getStepProperty(step, 'footerMessage')"
                        :class="step.footerMessageBold ? 'text-bold' : ''"
                        :style="config.footerMessageStyles"
                    ></div>
                    <!-- Footer -->
                    <div
                        class="app-footer"
                        :class="config.buttonsStyles"
                    >
                        <div v-if="currentIndex < config.steps.length - 1 && step.id !== 'plans' && !step.goToStep && !step.finishStep && !step.hideNextButton">
                            <v-btn @click="nextStep()" class="app-button-next">
                                {{ str['next'] }}
                            </v-btn>
                        </div>
                        <div v-if="step.registerButton">
                            <v-btn @click="handleStepRegisterButton()" class="app-button-next">
                                {{ step.registerButton.text }}
                            </v-btn>
                        </div>
                        <div v-if="currentIndex < config.steps.length - 1 && !step.finishStep && !step.hideBackButton && !config.backTop">
                            <v-btn @click="backStep()" class="app-button-back">
                                <i class="fa fa-chevron-left"></i>
                                <span>
                                    {{ str['back'] }}
                                </span>
                            </v-btn>
                        </div>
                        <div v-if="step.showBackRefuseRegisterButton && !step.hideBackButtonTimeoutActive && !config.backTop">
                            <v-btn @click="backStepAndRefuseRegister()" class="app-button-back">
                                <i class="fa fa-chevron-left"></i>
                                <span>
                                    {{ str['back'] }}
                                </span>
                            </v-btn>
                        </div>
                        <div v-if="(currentIndex === config.steps.length - 1 || step.finishStep) && !subscriptionProcessing">
                            <v-btn
                                v-if="openedByApp && !validatePaymentLink"
                                @click="finish()"
                                class="app-button-next"
                            >
                                {{ str['finish'] }}
                            </v-btn>
                            <v-btn
                                v-if="validatePaymentLink"
                                @click="openValidatePayment()"
                                class="app-button-next"
                            >
                                {{ str['confirm'] }}
                            </v-btn>
                        </div>
                        <div v-if="(currentIndex === config.steps.length - 1 || step.finishStep) && subscriptionProcessing">
                            <v-btn
                                @click="openValidatePayment()"
                                class="app-button-next"
                            >
                                {{ str['try_again'] }}
                            </v-btn>
                        </div>
                        <div v-if="(currentIndex === config.steps.length - 1 || step.finishStep) && subscriptionProcessing">
                            <v-btn
                                @click="cancelValidatePayment()"
                                class="app-button-back"
                            >
                                {{ str['cancel'] }}
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Api from '../services/Api'
    import ChatApi from '../services/ChatApi'
    import Utils from '../services/Utils'
    import StripeSubscription from '@/components/StripeSubscription'
    import Photo from '@/components/Photo'
    import VideoElement from '@/components/Video'
    import moment from 'moment'

    export default {
        components: {
            StripeSubscription,
            Photo,
            VideoElement,
        },
        data() {
            return {
                str: null,
                stepIndex: 0,
                openedByApp: window.openedByApp,
                language: window.language,
                apiFailed: false,
                initialized: false,
                registerCreated: false,
                processing: false,
                datepicker: false,
                timepicker: {},
                defaultBirthDate: Utils.getDefaultBirthDate(),
                datepickerLanguage: window.datepickerLanguage,
                currentDate: Utils.getFormatDate(),
                config: {},
                visiblePasswords: [],
                planKey: 'paym_subt',
                termsValue: false,
                registerSuccessData: null,
                currency: null,
                validatePaymentLink: null,
                subscriptionFailed: false,
                subscriptionProcessing: false,
                mobilePhonePrefixs: {},
                mobilePhonePrefixsList: [],
                subscriptionPaymentActive: false,
                mobilePhoneIndicative: '+351',
                datepickerInline: {
                    year: (new Date()).getFullYear() - 18,
                    month: 1,
                    day: 1,
                },
                selectSearchItems: [],
                selectSearchItemsSearch: '',
                videoHeight: '0',
                proofType: 0,
                promoFreeType: 98,
                manualRegistersType: 99,
                manualReturnRegistersType: 100,
                subscriptionReturnRegistersType: 101,
                isProcessing: false,
                datepickerFormatsToValidate: ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD', 'DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY', 'DDMMYYYY', 'YYYYMMDD', 'D/MMM/YYYY', 'YYYY/M/D', 'DD-MM/YYYY', 'D/M/YYYY', 'DD-MMYYYY', 'YYYY MM DD', 'DD/MM/YY', 'YYMMDD'],
            }
        },
        beforeMount: function () {
            this.receiveWebviewEvents()
            this.getStrings()
        },
        methods: {
            receiveWebviewEvents: function () {
                const self = this
                window.addEventListener('message', function (event) {
                    try {
                        if (event && event.data === 'close-view') {
                            self.closeAppView()
                        }
                    } catch { }
                })
                document.addEventListener('message', function (event) {
                    try {
                        if (event && event.data === 'close-view') {
                            self.closeAppView()
                        }
                    } catch { }
                })
            },
            getStrings: function () {
                const self = this
                this.apiFailed = false
                Api.getStrings(function (response) {
                    if (response.success) {
                        window.strings = response.data
                        self.str = response.data
                        self.main()
                    } else {
                        self.apiFailed = true
                    }
                })
            },
            main: function () {
                const self = this
                this.$isLoading(true)
                this.getIpAddress()
                Utils.refreshAppUrl()
                Api.getEnums(function () {
                    Api.getRegisterConfig(function (response) {
                        self.$isLoading(false)
                        if (response.success) {
                            self.refreshData(response.data)
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                })
            },
            getIpAddress: function () {
                const self = this
                try {
                    fetch('https://api.ipify.org?format=json')
                        .then(response => response.json())
                        .then(function (data) {
                            self.ipAddress = data.ip
                        })
                } catch { }
            },
            refreshData: function (config) {
                Utils.validateSubscriptionFields(config)
                if (!this.openedByApp && config.externalBackgroundColor) {
                    config.backgroundColor = config.externalBackgroundColor
                }
                Utils.setConfigStrings(config)
                this.config = config
                this.addScripts()
                Utils.refreshAppUrl(this.config)
                Utils.useSubscriptionValidation(this.config)
                this.refreshSteps()
                this.refreshPage()
                this.setRegisterDataCache()
            },
            addScripts: function () {
                const scripts = this.config && this.config.scripts ? this.config.scripts : null
                if (scripts) {
                    const tempDiv = document.createElement('div')
                    tempDiv.innerHTML = scripts
                    const scriptTags = tempDiv.querySelectorAll('script')
                    scriptTags.forEach(function(scriptTag) {
                        const newScript = document.createElement('script')
                        newScript.innerHTML = scriptTag.innerHTML
                        document.head.appendChild(newScript)
                    })
                    tempDiv.remove()
                }
            },
            refreshPage: function () {
                const self = this
                window.scrollTo(0, 0)
                Utils.refreshStyles(this.config, function () {
                    self.initialized = true
                })

                if (self.config.steps[self.stepIndex] && self.config.steps[self.stepIndex].hideBackButtonTimeout) {
                    delete self.config.steps[self.stepIndex].hideBackButtonTimeoutActive
                    clearTimeout(self.hideBackButtonTimeout)
                    self.hideBackButtonTimeout = setTimeout(function () {
                        clearTimeout(self.hideBackButtonTimeout)
                        const currentStep = self.config.steps[self.stepIndex]
                        if (currentStep && currentStep.hideBackButtonTimeout) {
                            currentStep.hideBackButtonTimeoutActive = true
                            self.$set(self.config.steps, self.stepIndex, currentStep)
                        }
                    }, self.config.steps[self.stepIndex].hideBackButtonTimeout)
                }

                if (self.config.steps[self.stepIndex] && self.config.steps[self.stepIndex].video &&
                    self.config.steps[self.stepIndex].local && !self.config.steps[self.stepIndex].height
                ) {
                    setTimeout(function () {
                        const id = self.config.steps[self.stepIndex].id + '-video-element'
                        const buttonHeight = document.getElementsByClassName('app-button-next') && document.getElementsByClassName('app-button-next')[0] ? (document.getElementsByClassName('app-button-next')[0].clientHeight + 30) : 0
                        self.videoHeight = (document.body.clientHeight - document.getElementById(id).offsetTop - buttonHeight) + 'px'
                    })
                }

                if (self.config.steps[self.stepIndex] && self.config.steps[self.stepIndex].openLink) {
                    window.location.href = self.config.steps[self.stepIndex].openLink
                }
            },
            refreshSteps: function () {
                const self = this
                for (let i = this.config.steps.length - 1; i > -1; i--) {
                    if (this.config.steps[i].showBackButtonApp && window.openedByApp) {
                        delete this.config.steps[i].hideBackButton
                    }
                    if (this.config.steps[i].fields) {
                        for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                            if (this.config.steps[i].fields[f].type === 'select' ||
                                this.config.steps[i].fields[f].type === 'select_search' ||
                                this.config.steps[i].fields[f].type === 'select_search_dialog' ||
                                this.config.steps[i].fields[f].type === 'tags' ||
                                this.config.steps[i].fields[f].type === 'buttons' ||
                                this.config.steps[i].fields[f].type === 'multiselect' ||
                                this.config.steps[i].fields[f].type === 'multiselect_search'
                            ) {
                                if (this.config.steps[i].fields[f].type === 'tags') {
                                    this.config.steps[i].fields[f].value = []
                                }
                                if (this.config.steps[i].fields[f].id === 'gender') {
                                    this.config.steps[i].fields[f].items = Utils.getGenders()
                                }
                                if (this.config.steps[i].fields[f].id === 'physical_condition') {
                                    this.config.steps[i].fields[f].items = Utils.getPhysicalConditions()
                                }
                                if (this.config.steps[i].fields[f].id === 'goal') {
                                    this.config.steps[i].fields[f].items = Utils.getGoals()
                                }
                                if (this.config.steps[i].fields[f].enumsKey && Utils[this.config.steps[i].fields[f].enumsKey]) {
                                    this.config.steps[i].fields[f].items = Utils[this.config.steps[i].fields[f].enumsKey]()
                                }
                                if (this.config.steps[i].fields[f].request && !this.config.steps[i].fields[f].request.cache) {
                                    Api.getRequest({
                                        url: this.config.steps[i].fields[f].request.url,
                                        item: this.config.steps[i].fields[f]
                                    }, function (response) {
                                        let requestItems = []
                                        if (response.success) {
                                            const responseData = response.data && response.data.data ? response.data.data : response.data
                                            const requestItem = response.item
                                            let requestKey = null
                                            let onlyUseKeyName = false

                                            if (requestItem.request.key) {
                                                requestKey = requestItem.request.key
                                            }
                                            if (requestItem.request.key_name) {
                                                requestKey = requestItem.request.key_name
                                                onlyUseKeyName = true
                                            }

                                            for (let i = 0; i < responseData.length; i++) {
                                                let keyValue = responseData[i]
                                                if (requestKey) {
                                                    switch (requestKey.length) {
                                                        case 1:
                                                            if (requestKey[0].indexOf('<lng>') > -1) {
                                                                const requestKeyLng = requestKey[0].replace('<lng>', window.language)
                                                                if (responseData[i][requestKeyLng]) {
                                                                    keyValue = responseData[i][requestKeyLng]
                                                                } else {
                                                                    keyValue = responseData[i][requestKey[0].replace('_<lng>', '')]
                                                                }
                                                            } else {
                                                                keyValue = responseData[i][requestKey[0]]
                                                            }
                                                            break
                                                        case 2:
                                                            keyValue = responseData[i][requestKey[0]][requestKey[1]]
                                                            break
                                                        case 3:
                                                            keyValue = responseData[i][requestKey[0]][requestKey[1]][requestKey[2]]
                                                            break
                                                    }
                                                }

                                                if (requestItem.id === 'country' &&
                                                    responseData[i].idd &&
                                                    responseData[i].idd.root &&
                                                    responseData[i].idd.suffixes
                                                ) {
                                                    self.mobilePhonePrefixs[keyValue] = responseData[i].idd.root + responseData[i].idd.suffixes.join('')
                                                    if (self.mobilePhonePrefixs[keyValue].length < 6 && self.mobilePhonePrefixs[keyValue].indexOf('+') > -1) {
                                                        self.mobilePhonePrefixsList.push({
                                                            label: self.mobilePhonePrefixs[keyValue],
                                                            value: self.mobilePhonePrefixs[keyValue]
                                                        })
                                                    }
                                                }

                                                const obj = {
                                                    label: requestKey ? keyValue : Utils.capitalize(responseData[i].name),
                                                    value: requestKey && !onlyUseKeyName ? keyValue : responseData[i].id
                                                }
                                                requestItems.push(obj)

                                                if (requestItem.request.filter) {
                                                    if (!requestItem.request.filter.values) {
                                                        requestItem.request.filter.values = {}
                                                    }
                                                    if (responseData[i][requestItem.request.filter.fieldToUse]) {
                                                        requestItem.request.filter.values[obj.value] = responseData[i][requestItem.request.filter.fieldToUse].split(', ')
                                                    }
                                                }
                                            }

                                            if (self.mobilePhonePrefixsList && self.mobilePhonePrefixsList.length) {
                                                self.mobilePhonePrefixsList = self.mobilePhonePrefixsList.sort((a, b) => a.label - b.label)
                                            }

                                            requestItems = requestItems.sort((a, b) => a.label.localeCompare(b.label))

                                            if (requestItem.request.filter && requestItem.request.filter.values) {
                                                self.config.steps.forEach(function (st) {
                                                    if (st.fields) {
                                                        st.fields.forEach(function (fd) {
                                                            if (fd.request && fd.request.cache && fd.request.filter && fd.request.url === requestItem.request.url) {
                                                                fd.request.filter.values = requestItem.request.filter.values
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        }

                                        response.item.items = requestItems
                                        self.setRequestCache(response.item)
                                    })
                                }
                            }

                            if (window.parameterEmail && this.config.steps[i].fields[f].id === 'email') {
                                this.config.steps[i].fields[f].value = window.parameterEmail
                                this.config.steps[i].fields[f].disabled = true
                            }

                            if (window.parameterName && this.config.steps[i].fields[f].id === 'name') {
                                this.config.steps[i].fields[f].value = window.parameterName
                                this.config.steps[i].fields[f].disabled = true
                            }

                            if (window.parameterName && this.config.steps[i].fields[f].id === 'mobile_phone') {
                                this.config.steps[i].fields[f].value = window.parameterMobilePhone
                                this.config.steps[i].fields[f].disabled = true
                            }

                            if (this.config.setLanguageContactCode &&
                                this.config.steps[i].fields[f].id === this.config.setLanguageContactCode.id &&
                                this.config.setLanguageContactCode.values &&
                                this.config.setLanguageContactCode.values[window.language]
                            ) {
                                this.config.steps[i].fields[f].value = this.config.setLanguageContactCode.values[window.language]
                            }
                        }
                    }

                    if (this.config.steps[i].id === 'plans' && this.config.steps[i].slide) {
                        if (window.planPreSelected || window.planPreSelected === 0) {
                            this.config.steps[i].slideIndex = window.planPreSelected
                        } else {
                            if (!this.config.steps[i].slideIndex) {
                                this.config.steps[i].slideIndex = 0
                            }
                        }
                    }

                    if (this.config.steps[i].video) {
                        if (this.config.steps[i].local) {
                            this.config.steps[i].video = require('@/assets/pts/' + window.ptId + '/' + this.config.steps[i].video)
                        } else {
                            this.config.steps[i].video = Utils.getYoutubeEmbedUrl(this.config.steps[i].video)
                        }
                    }

                    if (this.config.steps[i].id === 'terms' && this.config.steps[i].translations) {
                        this.config.steps[i].id = this.config.steps[i].translations[window.language]
                    }

                    // Packs
                    if (this.config.steps[i].id === 'select_subscription' || this.config.steps[i].getPacks) {
                        if (this.config.viva_wallet) {
                            const vivaWalletSubscriptionPlansStep = this.config.steps.find(function (st) {
                                return st.id === 'viva_wallet_subscription_plans'
                            })
                            const vivaWalletPlansStep = this.config.steps.find(function (st) {
                                return st.id === 'viva_wallet_plans'
                            })
                            const paymentsPacksCategoryStep = this.config.steps.find(function (st) {
                                return st.id === 'payments_packs_category'
                            })
                            if ((paymentsPacksCategoryStep && paymentsPacksCategoryStep.buttons && !paymentsPacksCategoryStep.buttons.length) ||
                                (vivaWalletSubscriptionPlansStep && vivaWalletSubscriptionPlansStep.buttons && !vivaWalletSubscriptionPlansStep.buttons.length && vivaWalletPlansStep && vivaWalletPlansStep.buttons && !vivaWalletPlansStep.buttons.length)
                            ) {
                                this.getPacks({
                                    code: this.getRegisterCachePromotionalCode(),
                                    callback: function (packs) {
                                        if (paymentsPacksCategoryStep) {
                                            for (let r = self.config.steps.length - 1; r > -1; r--) {
                                                if (self.config.steps[r] && self.config.steps[r].id === 'payments_packs_category') {
                                                    self.config.steps[r].buttons = packs
                                                    break
                                                }
                                            }
                                            return true
                                        }
                                        const subscriptionPacks = packs.filter(function (pack) {
                                            return pack.allow_recurring
                                        })
                                        const noSubscriptionPacks = JSON.parse(JSON.stringify(packs.filter(function (pack) {
                                            return pack.allow_one_time_payments
                                        })))
                                        for (let s = 0; s < noSubscriptionPacks.length; s++) {
                                            noSubscriptionPacks[s].allow_recurring = false
                                        }
                                        for (let r = self.config.steps.length - 1; r > -1; r--) {
                                            if (self.config.steps[r] && self.config.steps[r].backStep === 'select_subscription' && (!subscriptionPacks.length || !noSubscriptionPacks.length)) {
                                                delete self.config.steps[r].backStep
                                            }
                                            if (self.config.steps[r] && self.config.steps[r].id === 'select_subscription' && (!subscriptionPacks.length || !noSubscriptionPacks.length)) {
                                                if (subscriptionPacks.length || noSubscriptionPacks.length) {
                                                    self.config.steps.splice(r, 1)
                                                } else {
                                                    delete self.config.steps[r].buttons
                                                    delete self.config.steps[r].goToStep
                                                    self.config.steps[r].image = 'https://ptclient.mkgest.com/app/media/payment_failed.png'
                                                    self.config.steps[r].info = window.strings['payments_packs_empty']
                                                    self.config.steps[r].hideNextButton = true
                                                }
                                                continue
                                            }
                                            if (self.config.steps[r] && self.config.steps[r].id === 'viva_wallet_subscription_plans') {
                                                if (subscriptionPacks.length) {
                                                    self.config.steps[r].buttons = subscriptionPacks
                                                } else {
                                                    self.config.steps.splice(r, 1)
                                                }
                                                continue
                                            }
                                            if (self.config.steps[r] && self.config.steps[r].id === 'viva_wallet_plans') {
                                                if (noSubscriptionPacks.length) {
                                                    self.config.steps[r].buttons = noSubscriptionPacks
                                                } else {
                                                    self.config.steps.splice(r, 1)
                                                }
                                                continue
                                            }
                                        }
                                    }
                                })
                            }
                        } else {
                            const key = window.useHotmart ? 'hotmart_plans' : 'stripe_plans'
                            const plansStepIndex = this.config.steps.findIndex(function (st) {
                                return st.id === key
                            })
                            const plansStep = this.config.steps[plansStepIndex]
                            if (plansStep && plansStep.buttons && !plansStep.buttons.length) {
                                this.getPacks({
                                    callback: function (packs) {
                                        if (packs.length) {
                                            plansStep.buttons = packs
                                        } else {
                                            self.config.steps.splice(plansStepIndex, 1)
                                            for (let r = self.config.steps.length - 1; r > -1; r--) {
                                                if (self.config.steps[r].id === 'select_subscription') {
                                                    if (self.config.steps[r].buttons) {
                                                        const btnIndex = self.config.steps[r].buttons.findIndex(function (btn) {
                                                            return btn.step === key
                                                        })
                                                        if (btnIndex > -1) {
                                                            self.config.steps[r].buttons.splice(btnIndex, 1)
                                                        }
                                                    }
                                                    break
                                                }
                                            }
                                        }
                                        self.checkProofStepPacks(packs)
                                    }
                                })
                            }
                        }
                    }
                    if (this.config.steps[i].id === 'payments_packs_categories') {
                        const packsCategories = Utils.getPaymentPacksCategories()
                        const cats = []
                        if (packsCategories) {
                            packsCategories.forEach(function (c) {
                                cats.push({
                                    id: c.value,
                                    textColor: self.config.packTextColor,
                                    backgroundColor: self.config.packBackgroundColor,
                                    text: c.label
                                })
                            })
                        }
                        this.config.steps[i].buttons = cats
                    }
                }
            },
            getPacks: function (args) {
                const self = this
                const callback = args.callback
                const code = args.code
                const category = args.category
                Api.getPacks({
                    code: code,
                    category: category
                }, function (response) {
                    if (response.success) {
                        const packs = []
                        response.data.forEach(function (pack) {
                            packs.push({
                                id: pack.id,
                                textColor: self.config.packTextColor,
                                backgroundColor: self.config.packBackgroundColor,
                                text: pack.name,
                                info: self.getPackInfo(pack),
                                amount: pack.price,
                                signup_fee: pack.signup_fee,
                                allow_recurring: pack.allow_recurring ? true : false,
                                allow_one_time_payments: pack.allow_one_time_payments ? true : false,
                                allow_installments: pack.allow_installments ? true : false,
                                paym_subt: pack.type,
                                url: pack.url
                            })
                        })
                        callback(packs)
                    } else {
                        self.$isLoading(false)
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            getPackInfo: function (pack) {
                const price = pack.price / 100
                const split = pack.type.split('#')
                const type = split[1]
                const quantity = parseInt(split[0])
                let key = ''
                if (type === 'day') {
                    key = quantity > 1 ? 'days' : 'day'
                }
                if (type === 'week') {
                    key = quantity > 1 ? 'weeks' : 'week'
                }
                if (type === 'month') {
                    key = quantity > 1 ? 'months' : 'month'
                }
                if (type === 'year') {
                    key = quantity > 1 ? 'years' : 'year'
                }
                return price + '€ / ' + (quantity > 1 ? (quantity + ' ') : '') + (key ? window.strings[key] : type)
            },
            checkProofStepPacks: function (packs) {
                const proofStep = this.config.steps.find(function (s) {
                    return s.id === 'proof'
                })
                if (proofStep && proofStep.fields) {
                    const index = proofStep.fields.findIndex(function (f) {
                        return f.id === 'paym_subt'
                    })
                    if (index > -1 && proofStep.fields[index] && proofStep.fields[index].items && !proofStep.fields[index].items.length) {
                        if (packs && packs.length) {
                            const items = []
                            packs.forEach(function (p) {
                                items.push({
                                    label: p.text,
                                    value: p.text
                                })
                            })
                            proofStep.fields[index].items = items
                        } else {
                            proofStep.fields.splice(index, 1)
                        }
                    }
                }
            },
            setRegisterDataCache: function () {
                try {
                    if (window.appCache && window.appCache.registerData) {
                        const data = JSON.parse(window.appCache.registerData)
                        if (data.steps && (data.stepIndex || data.stepIndex === 0)) {
                            this.config.steps = data.steps
                            this.stepIndex = data.stepIndex
                        }
                        return true
                    }
                    if (!window.openedByApp) {
                        let cacheData = sessionStorage.getItem('register-cache')
                        try {
                            if (cacheData) {
                                cacheData = JSON.parse(cacheData)
                                if (cacheData && cacheData.steps && (cacheData.stepIndex || cacheData.stepIndex === 0) && cacheData.registerId) {
                                    this.config.steps = cacheData.steps
                                    this.stepIndex = cacheData.stepIndex
                                    this.vivaWalletPackSelected = cacheData.vivaWalletPackSelected
                                    this.promotionalCode = cacheData.promotionalCode
                                    if (this.config.prevent_refuse) {
                                        this.registerSuccessData = this.registerSuccessData ? this.registerSuccessData : {}
                                        this.registerSuccessData.id = cacheData.registerId
                                    } else {
                                        Api.refuseRegister(cacheData.registerId, function () { })
                                    }
                                }
                            }
                        } catch { }
                        sessionStorage.removeItem('register-cache')
                    }
                } catch { }
            },
            getRegisterCachePromotionalCode: function () {
                try {
                    if (!window.openedByApp) {
                        let cacheData = sessionStorage.getItem('register-cache')
                        if (cacheData) {
                            cacheData = JSON.parse(cacheData)
                            if (cacheData && cacheData.promotionalCode) {
                                return cacheData.promotionalCode
                            }
                        }
                    }
                } catch { }
                return null
            },
            setRequestCache: function (item) {
                if (item.request) {
                    for (let i = 0; i < this.config.steps.length; i++) {
                        if (this.config.steps[i].fields) {
                            for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                                const field = this.config.steps[i].fields[f]
                                if (field.request && field.request.cache && field.request.url === item.request.url) {
                                    field.items = JSON.parse(JSON.stringify(item.items))
                                }
                            }
                        }
                    }
                }
            },
            getStepProperty: function (step, key) {
                // Payment failed
                if (this.subscriptionFailed) {
                    if (step[key + '_failed_payment']) {
                        return step[key + '_failed_payment']
                    }
                    return step[key]
                }
                // Payment processing
                if (this.subscriptionProcessing) {
                    if (step[key + '_process_payment']) {
                        return step[key + '_process_payment']
                    }
                    return step[key]
                }
                // Payment
                if (this.validatePaymentLink) {
                    if (step[key + '_valid_payment']) {
                        return step[key + '_valid_payment']
                    }
                    return step[key]
                }
                return step[key]
            },
            checkItemCondition: function (fields, item) {
                if (fields && item && item.valueCondition) {
                    const parent = fields.find(function (elem) {
                        return elem.parentCondition === item.id ||
                            (typeof elem.parentCondition === 'object' &&
                                elem.parentCondition.indexOf(item.id) > -1)
                    })
                    if (parent && (parent.value !== item.valueCondition &&
                        ((typeof item.valueCondition === 'object' && item.valueCondition.indexOf(parent.value) === -1) ||
                            typeof item.valueCondition !== 'object'
                        ))
                    ) {
                        item.value = ''
                        return false
                    }
                }
                if (item.hidden) {
                    return false
                }
                return true
            },
            changeDatepicker: function (date) {
                if (date) {
                    const formattedDate = moment(date, this.datepickerFormatsToValidate, true).format('YYYY-MM-DD')
                    this.config.steps[this.stepIndex].fields.forEach(field => {
                        if (field.type === 'datepicker') {
                            field.value = formattedDate
                        }
                    })
                } else {
                    this.config.steps[this.stepIndex].fields.forEach(field => {
                        if (field.type === 'datepicker') {
                            field.value = date
                        }
                    })
                }
                this.datepicker = false
            },
            changeTimepicker: function (date, item) {
                item.value = date
                this.timepicker[item.id] = false
            },
            onChangeInput: function (item) {
                if (item && item.id === 'email' && item.value) {
                    item.value = item.value.toLowerCase()
                    item.value = item.value.trim()
                }
            },
            onChangeSelect: function (item) {
                const self = this
                if (item && item.value && item.triggerValue) {
                    this.handleTriggerValue(item)
                }
                if (item && item.value && item.triggerValues) {
                    item.triggerValues.forEach(function (value) {
                        self.handleTriggerValue({
                            triggerValue: value,
                            value: item.value
                        })
                    })
                }
            },
            handleTriggerValue: function (item) {
                const self = this
                let value = ''
                if (item.triggerValue.id === 'mobile_phone' && !item.triggerValue.value) {
                    value = this.mobilePhonePrefixs[item.value] ? this.mobilePhonePrefixs[item.value] : ''
                } else {
                    if (item.triggerValue.values) {
                        const valueActive = item.triggerValue.values.find(function (vl) {
                            return vl.value === item.value
                        })
                        if (valueActive) {
                            const currentStep = self.config.steps[self.stepIndex]
                            const field = currentStep.fields.find(function (it) {
                                return it.id === item.triggerValue.id
                            })
                            if (field) {
                                if (field.type === 'select' ||
                                    field.type === 'select_search' ||
                                    field.type === 'select_search_dialog' ||
                                    field.type === 'multiselect' ||
                                    field.type === 'multiselect_search'
                                ) {
                                    field.value = field.value ? field.value : []
                                    if (valueActive.addValue) {
                                        valueActive.addValue.forEach(function (vl) {
                                            if (field.value.indexOf(vl) === -1) {
                                                field.value.push(vl)
                                            }
                                        })
                                    }
                                    if (valueActive.removeValue) {
                                        valueActive.removeValue.forEach(function (vl) {
                                            const index = field.value.indexOf(vl)
                                            if (index > -1) {
                                                field.value.splice(index, 1)
                                            }
                                        })
                                    }
                                } else {
                                    field.value = valueActive
                                }
                            }
                        }
                        return true
                    } else {
                        value = item.triggerValue.value
                    }
                }
                if (value) {
                    setTimeout(function () {
                        const currentStep = self.config.steps[self.stepIndex]
                        const field = currentStep.fields.find(function (it) {
                            return it.id === item.triggerValue.id
                        })
                        if (field && field.value.indexOf(value) === -1) {
                            field.value = value
                        }
                    })
                }
            },
            showPassword: function (item) {
                const index = this.visiblePasswords.indexOf(item.id)
                if (index > -1) {
                    this.visiblePasswords.splice(index, 1)
                } else {
                    this.visiblePasswords.push(item.id)
                }
            },
            receivePhoto: function (photoBase64, index) {
                const currentStep = this.config.steps[this.stepIndex]
                this.$set(currentStep.photos, index, photoBase64)
            },
            receiveVideo: function (videoId, index) {
                const currentStep = this.config.steps[this.stepIndex]
                this.$set(currentStep.videos, index, videoId)
            },
            backStep: function () {
                if (this.stepIndex > 0) {
                    const currentStep = this.config.steps[this.stepIndex]
                    this.initialized = false

                    if (currentStep.backStep) {
                        const backStepIndex = this.config.steps.findIndex(function (item) {
                            return item.id === currentStep.backStep
                        })
                        this.stepIndex = backStepIndex
                    } else {
                        this.stepIndex -= 1
                    }

                    this.refreshPage()
                } else {
                    this.closeAppView()
                }
            },
            backStepAndRefuseRegister: function () {
                const self = this
                const message = window.strings[this.config.steps[this.stepIndex].showBackRefuseRegisterMessage] ? window.strings[this.config.steps[this.stepIndex].showBackRefuseRegisterMessage] : this.config.steps[this.stepIndex].showBackRefuseRegisterMessage

                if (message) {
                    this.$confirm(
                        message,
                        null,
                        null,
                        Utils.getAlertOptions()
                    ).then(() => {
                        confirmBack()
                    }).catch(() => { })
                } else {
                    confirmBack()
                }

                function confirmBack() {
                    const registerId = self.registerSuccessData ? self.registerSuccessData.id : null
                    self.$isLoading(true)
                    Api.refuseRegister(registerId, function (response) {
                        self.$isLoading(false)
                        if (response.success) {
                            self.registerCreated = false
                            self.backStep()
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                }
            },
            nextStep: function (args) {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]
                const finish = args && args.finish ? args.finish : null
                const nextStepId = args && args.nextStepId ? args.nextStepId : null
                const valueSelected = args && args.valueSelected ? args.valueSelected : null
                const proofDescription = args && args.proofDescription ? args.proofDescription : null
                const showSuccessPage = args && args.showSuccessPage ? args.showSuccessPage : null

                if (!this.validateStepCheckbox()) {
                    return true
                }

                if (currentStep.id === 'select_subscription') {
                    this.proofDescription = proofDescription
                }

                if (currentStep.id === 'photos') {
                    let photosValidated = true

                    if (currentStep.requiredPhotos) {
                        let counter = 0
                        for (let i = 0; i < currentStep.photos.length; i++) {
                            if (currentStep.photos[i]) {
                                counter += 1
                            }
                        }

                        if (counter < currentStep.requiredPhotos) {
                            photosValidated = false
                        }
                    }

                    if (photosValidated) {
                        if (!validateGoToStepId()) {
                            newStep()
                        }
                    } else {
                        this.$alert(
                            window.strings[currentStep.failedMessage] ? window.strings[currentStep.failedMessage] : currentStep.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }

                    return true
                }

                if (currentStep.id === 'videos') {
                    let videosValidated = true

                    if (currentStep.requiredVideos) {
                        let counter = 0
                        for (let i = 0; i < currentStep.videos.length; i++) {
                            if (currentStep.videos[i] === 'processing') {
                                videosValidated = false
                                return this.$alert(
                                    window.strings['processing'],
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                            if (currentStep.videos[i]) {
                                counter += 1
                            }
                        }

                        if (counter < currentStep.requiredVideos) {
                            videosValidated = false
                        }
                    }

                    if (videosValidated) {
                        if (!validateGoToStepId()) {
                            newStep()
                        }
                    } else {
                        this.$alert(
                            window.strings[currentStep.failedMessage] ? window.strings[currentStep.failedMessage] : currentStep.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }

                    return true
                }

                if (currentStep.fields && currentStep.id !== 'subscription' && currentStep.id !== 'proof' && !currentStep.finish) {
                    if (this.validateFields()) {
                        if (!validateGoToStepId()) {
                            newStep()
                        }
                    }
                    return true
                }

                if (currentStep.id === 'plans') {
                    if (!validateGoToStepId()) {
                        newStep()
                    }
                    return true
                }

                if (currentStep.id === 'terms' || currentStep.check_text) {
                    if (!this.termsValue) {
                        return this.$alert(
                            window.strings[currentStep.failedMessage] ? window.strings[currentStep.failedMessage] : currentStep.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                    if (!validateGoToStepId()) {
                        newStep()
                    }
                    return true
                }

                if (currentStep.id === 'currency') {
                    this.currency = valueSelected
                    if (!validateGoToStepId()) {
                        newStep()
                    }
                    return true
                }

                if (nextStepId) {
                    const newStepIndexFound = this.config.steps.findIndex(function (st) {
                        return st.id === nextStepId
                    })
                    newStep(newStepIndexFound)
                    return true
                }

                if ((this.stepIndex === this.config.steps.length - 2 || currentStep.callRegister || currentStep.finish) && !finish) {
                    if (currentStep.id === 'subscription') {
                        if (this.$refs.stripeRef[0].validated()) {
                            this.register()
                        }
                    } else {
                        if ((currentStep.photos && currentStep.photos[0]) || currentStep.finish) {
                            if (currentStep.fields) {
                                if (this.validateFields()) {
                                    this.register()
                                }
                            } else {
                                this.register()
                            }
                        } else {
                            this.$alert(
                                window.strings[currentStep.failedMessage] ? window.strings[currentStep.failedMessage] : currentStep.failedMessage,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    }
                    return true
                }

                if (!validateGoToStepId()) {
                    newStep()
                    return true
                }

                return true

                function validateGoToStepId() {
                    if (currentStep.goToStepId) {
                        const newStepIndexFound = self.config.steps.findIndex(function (st) {
                            return st.id === currentStep.goToStepId
                        })
                        newStep(newStepIndexFound)
                        return true
                    }
                    return false
                }

                function newStep(newStepIndex) {
                    if (showSuccessPage) {
                        self.initialized = false
                        const successStepIndex = self.config.steps.findIndex(function (t) {
                            return t.id === 'success'
                        })
                        self.stepIndex = successStepIndex > -1 ? successStepIndex : (self.config.steps.length - 1)
                        self.refreshPage()
                        document.getElementById('user-login').setAttribute('data', window.userLoginAutomatic)
                        return true
                    }

                    if (self.config.subscription) {

                        if (window.isSeller && self.config.steps[self.stepIndex + 1].id === 'hotmart_plans') {
                            return self.registerWithSeller()
                        }

                        self.initialized = false

                        if (newStepIndex) {
                            self.stepIndex = newStepIndex
                        } else {
                            self.stepIndex += 1
                        }

                        self.refreshPage()

                        const newStep = self.config.steps[self.stepIndex]

                        if (newStep.id === 'subscription') {
                            self.subscriptionPaymentActive = true
                            self.openSubscriptionStep()
                        }

                        if (newStep.id === 'hotmart_plans') {
                            self.openHotmartPlansStep()
                        }

                        if (newStep.id === 'stripe_plans') {
                            self.openStripePlansStep()
                        }
                    } else {
                        const newStep = self.config.steps[self.stepIndex + 1]

                        if (newStep.id === 'subscription' ||
                            newStep.id === 'proof' ||
                            newStep.id === 'success' ||
                            newStep.id === 'plans' ||
                            newStep.id === 'select_subscription' ||
                            newStep.id === 'stripe_plans'
                        ) {
                            self.register()
                        } else {
                            self.initialized = false
                            self.stepIndex += 1
                            self.refreshPage()
                        }
                    }
                }
            },
            validateStepCheckbox: function () {
                const currentStep = this.config.steps[this.stepIndex]
                if (currentStep.checkbox && currentStep.checkbox.required && !currentStep.checkbox.value) {
                    this.$alert(
                        window.strings[currentStep.checkbox.required] ? window.strings[currentStep.checkbox.required] : currentStep.checkbox.required,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                    return false
                }
                return true
            },
            validateFields: function () {
                const currentStep = this.config.steps[this.stepIndex]
                let valid = true
                let fieldsValue = {}
                for (let i = 0; i < currentStep.fields.length; i++) {
                    const field = currentStep.fields[i]
                    fieldsValue[field.id] = field.value
                    if (field.required &&
                        !checkValue(field) &&
                        this.checkItemCondition(currentStep.fields, field)
                    ) {
                        valid = false
                    }
                    if (field.sameValue && fieldsValue[field.sameValue] !== field.value) {
                        this.$alert(
                            window.strings[field.failedMessage] ? window.strings[field.failedMessage] : field.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                        return false
                    }
                    if (field.required && field.minLength &&
                        field.minLength > field.value.toString().replace(/\s/g, '').length &&
                        field.minLengthMessage
                    ) {
                        this.$alert(
                            window.strings[field.minLengthMessage] ? window.strings[field.minLengthMessage] : field.minLengthMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                        return false
                    }
                    if (field.id === 'email' && checkValue(field)) {
                        field.value = field.value.toLowerCase()
                        field.value = field.value.trim()
                        if (!validateEmail(field.value)) {
                            this.$alert(
                                window.strings['invalid_email'],
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                            return false
                        }
                    }
                }
                if (valid) {
                    return true
                } else {
                    this.$alert(
                        window.strings[currentStep.emptyFailedMessage] ? window.strings[currentStep.emptyFailedMessage] : currentStep.emptyFailedMessage,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                    return false
                }

                function checkValue(fd) {
                    const valueStr = fd.value !== null ? fd.value.toString() : ''
                    if ((fd.biggerThen || fd.biggerThen === 0) && parseFloat(fd.value) <= fd.biggerThen) {
                        return false
                    }
                    if (valueStr.replace(/\s/g, '').length) {
                        return true
                    } else {
                        return false
                    }
                }

                function validateEmail(email) {
                    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return re.test(String(email).toLowerCase())
                }
            },
            openSubscriptionStep: function () {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]
                if (currentStep.promotionalCode) {
                    this.$prompt(
                        currentStep.promotionalCodeMessage ? currentStep.promotionalCodeMessage : this.str['do_you_have_promotional_code'],
                        '',
                        '',
                        '',
                        Utils.getAlertOptions()
                    ).then(text => {
                        self.getSubscriptionPlans({
                            code: text,
                            currency: self.currency
                        })
                    }).catch(() => {
                        self.getSubscriptionPlans({
                            currency: self.currency
                        })
                    })
                } else {
                    this.getSubscriptionPlans({
                        currency: self.currency
                    })
                }
            },
            applyPromotionalCode: function () {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]
                this.$prompt(
                    currentStep.promotionalCodeMessage ? currentStep.promotionalCodeMessage : this.str['do_you_have_promotional_code'],
                    '',
                    '',
                    '',
                    Utils.getAlertOptions()
                ).then(text => {
                    self.getSubscriptionPlans({
                        code: text,
                        currency: self.currency
                    })
                }).catch(() => { })
            },
            getSubscriptionPlans: function (payload) {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]
                const stepsIds = ['viva_wallet_subscription_plans', 'viva_wallet_plans', 'stripe_plans', 'hotmart_plans', 'payments_packs_category']
                if (stepsIds.indexOf(currentStep.id) > -1) {
                    if (payload.code) {
                        this.$isLoading(true)
                        this.getPacks({
                            code: payload.code,
                            callback: function (packs) {
                                if (packs && packs.length) {
                                    self.promotionalCode = payload.code
                                    self.config.steps[self.stepIndex].buttons = packs
                                    self.$set(self.config.steps, self.stepIndex, self.config.steps[self.stepIndex])
                                    self.$isLoading(false)
                                }
                            }
                        })
                    }
                } else {
                    this.$isLoading(true)
                    Api.getSubscriptionPlans(payload, function (response) {
                        self.$isLoading(false)
                        if (response.success) {
                            self.promotionalCode = payload.code
                            const currentStep = self.config.steps[self.stepIndex]
                            for (let i = 0; i < currentStep.fields.length; i++) {
                                if (currentStep.fields[i].id == 'price_id') {
                                    const newItems = []
                                    for (let s = 0; s < response.data.length; s++) {
                                        const priceJson = response.data[s].prices[0]
                                        if (priceJson) {
                                            newItems.push({
                                                label: currentStep.useNickname && priceJson.nickname ? priceJson.nickname : response.data[s].name,
                                                value: priceJson.id,
                                                order: response.data[s].metadata && response.data[s].metadata.order ? parseInt(response.data[s].metadata.order) : null
                                            })
                                        }
                                    }
                                    currentStep.fields[i].items = newItems.sort(function (a, b) {
                                        const itemA = a.order || a.order === 0 ? a.order : a.label.toLowerCase()
                                        const itemB = b.order || b.order === 0 ? b.order : b.label.toLowerCase()
                                        if (itemA < itemB) {
                                            return -1
                                        }
                                        if (itemA > itemB) {
                                            return 1
                                        }
                                        return 0
                                    })
                                    self.$set(currentStep.fields, i, currentStep.fields[i])
                                    break
                                }
                            }
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            ).then(() => {
                                self.openSubscriptionStep()
                            })
                        }
                    })
                }
            },
            register: function (onlyReturnData) {

                if (this.registerCreated) {
                    return false
                }

                if (!this.processing) {
                    this.processing = true
                    this.$isLoading(true)
                    const registerSrc = this.getRegisterData()

                    if (onlyReturnData) {
                        this.processing = false
                        return registerSrc.registerData
                    } else {
                        if (this.config.subscription) {
                            this.callRegisterService({
                                registerData: registerSrc.registerData,
                                stripeData: registerSrc.stripeData,
                                userData: registerSrc.userData,
                                proof: registerSrc.proof,
                                proofFields: registerSrc.proofFields
                            })
                        } else {
                            this.newClient(registerSrc.registerData)
                        }
                    }
                }
            },
            getRegisterData: function () {
                const self = this
                let registerData = {
                    'type': 1,
                    'questions': []
                }
                let stripeData = {}
                let userData = {}
                let proof = null
                let proofFields = null
                let jsonFieldsToConvert = []

                for (let s = 0; s < this.config.steps.length; s++) {
                    const step = this.config.steps[s]
                    switch (step.id) {
                        case 'details':
                            for (let i = 0; i < step.fields.length; i++) {
                                if (step.fields[i].save && this.checkItemCondition(step.fields, step.fields[i])) {
                                    let value = step.fields[i].value
                                    if (step.fields[i].inputType === 'numeric') {
                                        value = parseFloat(typeof value === 'string' ? value.replace(/,/g, '.') : value)
                                    }
                                    if (step.fields[i].inputType === 'integer') {
                                        value = value.toString()
                                        value = value.replace(/,/g, '').replace(/\./g, '')
                                        value = parseInt(value)
                                    }
                                    if (step.fields[i].inputType == 'email') {
                                        value = Utils.encodeEmail(value)
                                    }

                                    if (step.fields[i].id == 'password') {
                                        value = value.trim()
                                    }

                                    if ((step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') && typeof value === 'object') {
                                        value = value.join(', ')
                                    }

                                    if (step.fields[i].indicative) {
                                        value = this.mobilePhoneIndicative.toString() + value
                                    }

                                    if (step.fields[i].type == 'datepicker' && value) {
                                        value = moment(value, this.datepickerFormatsToValidate, true).format('YYYY-MM-DD')
                                    }

                                    if (step.fields[i].replaceId) {
                                        if (step.fields[i].saveJsonId) {
                                            if (jsonFieldsToConvert.indexOf(step.fields[i].replaceId) === -1) {
                                                jsonFieldsToConvert.push(step.fields[i].replaceId)
                                            }
                                            if (!registerData[step.fields[i].replaceId]) {
                                                registerData[step.fields[i].replaceId] = {}
                                            }
                                            registerData[step.fields[i].replaceId][step.fields[i].saveJsonId] = value
                                        } else {
                                            registerData[step.fields[i].replaceId] = value
                                        }
                                    } else if (step.fields[i].concatId) {
                                        registerData[step.fields[i].concatId] += (step.fields[i].concatSeparatorStart ? step.fields[i].concatSeparatorStart : '') + value + (step.fields[i].concatSeparatorEnd ? step.fields[i].concatSeparatorEnd : '')
                                    } else if (step.fields[i].updateUser) {
                                        userData[step.fields[i].id] = value
                                    } else {
                                        registerData[step.fields[i].id] = value
                                    }
                                }
                            }
                            break
                        case 'questions':
                            for (let i = 0; i < step.fields.length; i++) {
                                if (step.fields[i].save && this.checkItemCondition(step.fields, step.fields[i])) {
                                    let value = step.fields[i].value
                                    if (step.fields[i].inputType === 'numeric') {
                                        value = parseFloat(typeof value === 'string' ? value.replace(/,/g, '.') : value)
                                    }
                                    if (step.fields[i].inputType === 'integer') {
                                        value = value.toString()
                                        value = value.replace(/,/g, '').replace(/\./g, '')
                                        value = parseInt(value)
                                    }
                                    if (step.fields[i].replaceId) {
                                        if (step.fields[i].saveJsonId) {
                                            if (jsonFieldsToConvert.indexOf(step.fields[i].replaceId) === -1) {
                                                jsonFieldsToConvert.push(step.fields[i].replaceId)
                                            }
                                            if (!registerData[step.fields[i].replaceId]) {
                                                registerData[step.fields[i].replaceId] = {}
                                            }
                                            if (step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') {
                                                if (!registerData[step.fields[i].replaceId][step.fields[i].saveJsonId]) {
                                                    registerData[step.fields[i].replaceId][step.fields[i].saveJsonId] = []
                                                }
                                                if (typeof value === 'object') {
                                                    value.forEach(function (vl) {
                                                        const vlToSave = vl.value ? vl.value : vl
                                                        if (registerData[step.fields[i].replaceId][step.fields[i].saveJsonId].indexOf(vlToSave) === -1) {
                                                            registerData[step.fields[i].replaceId][step.fields[i].saveJsonId].push(vlToSave)
                                                        }
                                                    })
                                                } else {
                                                    if (registerData[step.fields[i].replaceId][step.fields[i].saveJsonId].indexOf(value) === -1) {
                                                        registerData[step.fields[i].replaceId][step.fields[i].saveJsonId].push(value)
                                                    }
                                                }
                                            } else {
                                                registerData[step.fields[i].replaceId][step.fields[i].saveJsonId] = value
                                            }
                                            if (step.fields[i].saveUserChat) {
                                                if (!this.userChatFieldsToSave) {
                                                    this.userChatFieldsToSave = {}
                                                }
                                                this.userChatFieldsToSave[step.fields[i].replaceId] = registerData[step.fields[i].replaceId]
                                            }
                                        } else {
                                            registerData[step.fields[i].replaceId] = value
                                        }
                                    }
                                    if (step.fields[i].updateUser) {
                                        userData[step.fields[i].id] = value
                                    }
                                    if ((!step.fields[i].replaceId && !step.fields[i].updateUser) || step.fields[i].saveQuestion) {
                                        let questionId = step.fields[i].id
                                        if ((this.config.translate || step.useTitle) && !step.fields[i].ignoreTitle) {
                                            questionId = step.fields[i].title
                                        }
                                        if (step.fields[i].useLabelValueQuestion && step.fields[i].value) {
                                            if (step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') {
                                                const newValueWithLabels = []
                                                step.fields[i].value.forEach(function (vl) {
                                                    const vlItem = step.fields[i].items.find(function (fIt) {
                                                        return fIt.value === vl
                                                    })
                                                    if (vlItem) {
                                                        newValueWithLabels.push(vlItem.label)
                                                    } else {
                                                        newValueWithLabels.push(vl)
                                                    }
                                                })
                                                value = newValueWithLabels
                                            } else {
                                                const vlItem = step.fields[i].items.find(function (fIt) {
                                                    return fIt.value === step.fields[i].value
                                                })
                                                value = vlItem ? vlItem.label : step.fields[i].value
                                            }
                                        }
                                        if ((step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') && typeof value === 'object') {
                                            value = value.join(', ')
                                        }
                                        const questionObj = {
                                            id: questionId,
                                            answer: value
                                        }
                                        if (step.fields[i].saveExtraFields) {
                                            step.fields[i].saveExtraFields.forEach(function (extraField) {
                                                questionObj[extraField] = step.fields[i][extraField]
                                            })
                                        }
                                        registerData.questions.push(questionObj)
                                    }
                                }
                            }
                            break
                        case 'subscription':
                            for (let i = 0; i < step.fields.length; i++) {
                                if (step.fields[i].save) {
                                    let value = step.fields[i].value
                                    if (step.fields[i].inputType == 'numeric') {
                                        value = parseFloat(typeof value === 'string' ? value.replace(/,/g, '.') : value)
                                    }
                                    stripeData[step.fields[i].id] = value
                                }
                            }
                            break
                        case 'proof':
                            if (step.fields) {
                                const proofFds = {}
                                for (let i = 0; i < step.fields.length; i++) {
                                    let proofFieldValue = step.fields[i].value
                                    if (step.fields[i].inputType === 'numeric') {
                                        proofFieldValue = parseFloat(typeof proofFieldValue === 'string' ? proofFieldValue.replace(/,/g, '.') : proofFieldValue)
                                    }
                                    if (step.fields[i].inputType === 'integer') {
                                        proofFieldValue = proofFieldValue.toString()
                                        proofFieldValue = proofFieldValue.replace(/,/g, '').replace(/\./g, '')
                                        proofFieldValue = parseInt(proofFieldValue)
                                    }
                                    if (step.fields[i].isRegisterField) {
                                        registerData[step.fields[i].id] = proofFieldValue
                                    } else {
                                        proofFds[step.fields[i].id] = proofFieldValue
                                    }
                                }
                                proofFields = proofFds
                            }
                            if (this.proofDescription) {
                                if (!proofFields) {
                                    proofFields = {}
                                }
                                proofFields.description = this.proofDescription
                            }
                            proof = step.photos[0]
                            break
                        case 'plans':
                            registerData[this.planKey] = step[this.planKey]
                            break
                    }

                    if (step.json_string) {
                        registerData[step.id] = [];
                        for (let i = 0; i < step.fields.length; i++) {
                            if (step.fields[i].save) {
                                registerData[step.id].push({
                                    id: step.fields[i].id,
                                    answer: step.fields[i].value
                                })
                            }
                        }
                        registerData[step.id] = JSON.stringify(registerData[step.id])
                    }
                }

                registerData.questions = JSON.stringify(registerData.questions)
                registerData.chat_token = window.chatToken ? window.chatToken : 'no_token'

                if (this.config.saveDeviceModel && window.appModel && window.appVersion) {
                    if (!registerData.notes) {
                        registerData.notes = {}
                    }
                    registerData.notes.device_model = window.appModel + ' | v' + window.appVersion
                }

                if (this.config.saveChatCountry) {
                    if (!registerData.notes) {
                        registerData.notes = {}
                    }
                    registerData.notes.country = registerData.country
                    if (!this.userChatFieldsToSave) {
                        this.userChatFieldsToSave = {}
                    }
                    if (!this.userChatFieldsToSave.notes) {
                        this.userChatFieldsToSave.notes = {}
                    }
                    this.userChatFieldsToSave.notes.country = registerData.country;
                    if (jsonFieldsToConvert.indexOf('notes') === -1) {
                        this.userChatFieldsToSave.notes = JSON.stringify(this.userChatFieldsToSave.notes)
                    }
                }

                if (jsonFieldsToConvert.length) {
                    jsonFieldsToConvert.forEach(function (fd) {
                        registerData[fd] = JSON.stringify(registerData[fd])
                        if (self.userChatFieldsToSave && self.userChatFieldsToSave[fd]) {
                            self.userChatFieldsToSave[fd] = JSON.stringify(self.userChatFieldsToSave[fd])
                        }
                    })
                }

                return {
                    registerData: registerData,
                    stripeData: stripeData,
                    userData: userData,
                    proof: proof,
                    proofFields: proofFields
                }
            },
            callRegisterService: function (args) {
                const self = this
                const registerData = args.registerData
                let registerId = null

                if (window.deviceId) {
                    registerData.device_id = window.deviceId;
                }

                if (!registerData.promo_code && this.promotionalCode) {
                    registerData.promo_code = this.promotionalCode
                }

                registerData.language = window.language

                if (this.config.prevent_refuse && this.registerSuccessData && this.registerSuccessData.id) {
                    registerData.id = this.registerSuccessData.id
                    Api.updateRegister(registerData, function (response) {
                        afterRegister(response)
                    })
                } else {
                    Api.register(registerData, function (response) {
                        afterRegister(response)
                    })
                }

                function afterRegister(response) {
                    if (response.success) {
                        self.registerCreated = true
                        registerId = response.data.id
                        self.registerSuccessData = {
                            id: registerId,
                            email: registerData.email,
                            name: registerData.name,
                            password: registerData.password,
                            mobile_phone: registerData.mobile_phone,
                        }
                        args.registerId = registerId
                        const photos = self.getAssets('photos', registerId)
                        if (photos.length) {
                            sendAssets(photos)
                        } else {
                            saved()
                        }
                    } else {
                        self.registrationFailed(null, response.message)
                    }
                }

                function sendAssets(assets) {
                    Api.newClientRegisterAssets(assets, function (response) {
                        if (response.success) {
                            saved()
                        } else {
                            self.registrationFailed(registerId, response.message)
                        }
                    })
                }

                function saved() {
                    if (self.config.autoValidateRegister) {
                        self.validateRegister({
                            id: self.registerSuccessData ? self.registerSuccessData.id : null,
                            user: args.userData,
                            callback: function () {
                                if (args.paymentDisabledCallback) {
                                    args.paymentDisabledCallback()
                                } else {
                                    self.newRegisterPayment(args)
                                }
                            }
                        })
                    } else {
                        if (args.paymentDisabledCallback) {
                            args.paymentDisabledCallback()
                        } else {
                            self.newRegisterPayment(args)
                        }
                    }
                }
            },
            getAssets: function (type, registerId) {
                const assets = []
                for (let s = 0; s < this.config.steps.length; s++) {
                    const step = this.config.steps[s]
                    if (step.id === type) {
                        for (let p = 0; p < step[type].length; p++) {
                            if (step[type][p]) {
                                assets.push({
                                    register_id: registerId,
                                    pt_id: window.ptId,
                                    photo: step[type][p],
                                    type: type === 'photos' ? 0 : 1
                                })
                            }
                        }
                        break
                    }
                }
                return assets
            },
            newRegisterPayment: function (args) {
                const withSubscription = this.hasRegisterStep('subscription')
                const withProof = this.hasRegisterStep('proof')

                if (withSubscription && (!withProof || (withProof && !args.proof))) {
                    return this.sendPaymentSubscription(args)
                }

                if (withProof) {
                    return this.sendPaymentProof(args)
                }

                this.registrationSuccess()
            },
            sendPaymentSubscription: function (args) {
                const self = this
                const registerData = args.registerData
                const stripeData = args.stripeData
                const registerId = args.registerId

                stripeData.pt_id = window.ptId
                stripeData.register = true
                stripeData.id = registerId
                stripeData.customer_email = registerData.email
                stripeData.customer_name = registerData.name
                stripeData.customer_description = 'APP ' + window.ptId + ' - ' + registerData.name

                const currentStep = self.config.steps[self.stepIndex]
                if (currentStep && currentStep.savePromoCode && self.promotionalCode) {
                    stripeData.code = self.promotionalCode
                }

                stripeData.ip = this.ipAddress

                Api.addSubscription(stripeData, function (response) {
                    if (response.success) {
                        if (response.data && response.data.linvoice_url) {
                            self.validatePaymentLink = response.data.linvoice_url
                        }
                        if (self.registerSuccessData) {
                            self.registerSuccessData.subscriptionId = response.data.sub_id
                        }
                        self.registrationSuccess()
                    } else {
                        self.registrationFailed(registerId, response.message)
                    }
                })
            },
            sendPaymentProof: function (args) {
                const self = this
                const registerId = args.registerId
                const proof = args.proof
                const proofFields = args.proofFields
                const data = {
                    id: registerId,
                    pt_id: window.ptId,
                    type: this.proofType,
                    proof: proof
                }

                if (proofFields) {
                    for (const key in proofFields) {
                        data[key] = proofFields[key]
                    }
                }

                const currentStep = this.config.steps[this.stepIndex]
                if (currentStep && currentStep.savePromoCode && this.promotionalCode) {
                    data.promo_code = this.promotionalCode
                }

                Api.sendRegisterPayment(data, function (response) {
                    if (response.success) {
                        self.registrationSuccess()
                    } else {
                        self.registrationFailed(registerId, response.message)
                    }
                })
            },
            sendPaymentPromoFree: function () {
                const self = this
                Api.sendRegisterPayment({
                    id: this.registerSuccessData.id,
                    pt_id: window.ptId,
                    type: this.promoFreeType,
                    promo_code: this.promotionalCode
                }, function (response) {
                    if (response.success) {
                        self.registrationSuccess(true)
                    } else {
                        self.registrationFailed(registerId, response.message)
                    }
                })
            },
            hasRegisterStep: function (id) {
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (this.config.steps[i].id === id) {
                        return true
                    }
                }
                return false
            },
            registrationSuccess: function (showSuccessPage) {
                const self = this
                try {
                    this.handleRegisterSuccess(function () {
                        self.$isLoading(false)
                        self.processing = false
                        self.nextStep({
                            finish: true,
                            showSuccessPage: showSuccessPage
                        })
                        if (!showSuccessPage) {
                            self.handleSubscriptionCheckSuccess()
                        }
                    })
                } catch { }
            },
            handleRegisterSuccess: function (callback) {
                try {
                    if (this.registerSuccessData) {
                        const userObj = {
                            id: this.registerSuccessData.id,
                            email: this.registerSuccessData.email,
                            name: this.registerSuccessData.name,
                            password: this.registerSuccessData.password
                        }

                        if (this.config.chat) {
                            return this.registerUserChat(userObj, function (chatId) {
                                userObj.chat_id = chatId
                                return finish();
                            })
                        }

                        return finish();

                        function finish() {
                            document.getElementById('success-view').setAttribute(
                                'data', JSON.stringify(userObj)
                            )
                            document.getElementById('success-view').click()
                            return callback()
                        }
                    }
                } catch { }

                return callback()
            },
            registerUserChat: async function (userObj, callback) {
                const self = this
                let newUserId = null

                if (this.registerUserChatCreated) {
                    newUserId = this.registerUserChatCreated
                } else {
                    newUserId = await newRegisterUser()
                    if (newUserId === 'error') {
                        return callback(null)
                    }
                    await newChat()
                    this.registerUserChatCreated = newUserId
                }

                await updateRegister()
                callback(newUserId)

                function newRegisterUser() {
                    return new Promise(resolve => {
                        ChatApi.getUserByEmail(userObj.email, function (response) {
                            if (response.success) {
                                if (response.data[0]) {
                                    resolve(response.data[0].id)
                                } else {
                                    newUser()
                                }
                            } else {
                                newUser()
                            }
                        })

                        function newUser() {
                            const payload = {
                                token: window.chatToken ? window.chatToken : 'no_token',
                                name: userObj.name,
                                email: userObj.email,
                                password: userObj.password
                            }
                            ChatApi.newUser(payload, function (response) {
                                if (response.success) {
                                    resolve(response.data.id)
                                } else {
                                    resolve('error')
                                }
                            })
                        }
                    })
                }

                function newChat() {
                    return new Promise(resolve => {
                        Api.getUser({ id: window.ptId }, function (response) {
                            if (response.success) {
                                const ptUser = response.data[0]
                                const newChatObj = {
                                    name: '[novo] - ' + userObj.name,
                                    type: 0,
                                    users: [ptUser.chat_id, newUserId]
                                }

                                if (self.userChatFieldsToSave) {
                                    for (const key in self.userChatFieldsToSave) {
                                        newChatObj[key] = self.userChatFieldsToSave[key]
                                    }
                                }

                                if (ptUser.chat_id) {
                                    ChatApi.newChat(newChatObj, function (response) {
                                        if (response.success) {
                                            resolve(response.data)
                                        } else {
                                            resolve('error')
                                        }
                                    })
                                } else {
                                    resolve('error')
                                }
                            } else {
                                resolve('error')
                            }
                        })
                    })
                }

                function updateRegister() {
                    return new Promise(resolve => {
                        const payload = {
                            id: userObj.id,
                            chat_id: newUserId
                        }
                        Api.updateRegister(payload, function (response) {
                            if (response.success) {
                                resolve(response.data)
                            } else {
                                resolve('error')
                            }
                        })
                    })
                }
            },
            registrationFailed: function (registerId, message) {
                const self = this
                this.registerCreated = false

                if (registerId) {
                    Api.refuseRegister(registerId, function (response) {
                        self.$isLoading(false)
                        self.processing = false
                        if (response.success) {
                            if (message) {
                                self.$alert(
                                    message,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                } else {
                    self.$isLoading(false)
                    self.processing = false
                    if (message) {
                        self.$alert(
                            message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                }
            },
            handleSubscriptionCheckSuccess: function () {
                const self = this

                try {
                    const obj = getSubscriptionObj()
                    const registerId = this.registerSuccessData ? this.registerSuccessData.id : null
                    const paymentStatusSuccess = obj.validate_proof ? [4, 99] : [4]
                    let timerValue = 0
                    let processing = false
                    let timeoutPromise = false

                    if (obj && obj.interval_time && obj.limit_time && this.subscriptionPaymentActive) {
                        callProcessPayment()
                    }

                    function getSubscriptionObj() {
                        if (self.config.subscription_check_success) {
                            return self.config.subscription_check_success
                        }
                        if (window.useHotmart) {
                            const subscriptionHotmartStep = self.config.steps.find(function (s) {
                                return s.id === 'subscription_hotmart'
                            })
                            if (subscriptionHotmartStep && subscriptionHotmartStep.subscription_check_success && subscriptionHotmartStep.subscription_check_success.validate_proof) {
                                self.subscriptionPaymentActive = true
                                return subscriptionHotmartStep.subscription_check_success
                            }
                        }
                        return null
                    }

                    function callProcessPayment() {
                        timerValue += obj.interval_time
                        if (!processing) {
                            processing = true
                            checkPaymentStatus(function (success) {
                                if (success) {
                                    self.refreshPaymentDesign(true)
                                    if (obj.validate_register) {
                                        self.sendEventToApp('register-data', self.registerSuccessData)
                                        self.validateRegister({
                                            id: registerId
                                        })
                                    }
                                    return true
                                }
                                if (timerValue >= obj.limit_time) {
                                    self.refreshPaymentDesign(false)
                                    self.cancelValidatePayment()
                                    return true
                                }
                                processing = false
                                startProcessPaymentPromise()
                            })
                        }
                    }

                    function startProcessPaymentPromise() {
                        clearTimeout(timeoutPromise)
                        timeoutPromise = setTimeout(function () {
                            callProcessPayment()
                        }, obj.interval_time)
                    }

                    function checkPaymentStatus(callback) {
                        Api.getRegister(registerId, function (response) {
                            if (response.success && response.data[0]) {
                                if (paymentStatusSuccess.indexOf(response.data[0].paym_sub_status) > -1) {
                                    return callback(true)
                                }
                                callback(false)
                            } else {
                                callback(false)
                            }
                        })
                    }
                } catch { }
            },
            validateRegister: function (args) {
                const self = this
                if (args && args.id) {
                    Api.validateRegister(args.id, function (response) {
                        if (response.success) {
                            updateUser(response.data && response.data.id ? response.data.id : null)
                        } else {
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                            finish()
                        }
                    })
                } else {
                    finish()
                }

                function updateUser(userId) {
                    if (args && args.user && userId) {
                        args.user.id = userId
                        Api.updateUser(args.user, function (response) {
                            if (!response.success) {
                                self.$alert(
                                    response.message,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                            finish()
                        })
                    } else {
                        finish()
                    }
                }

                function finish() {
                    if (args && args.callback) {
                        args.callback()
                    }
                }
            },
            refreshPaymentDesign: function (success) {
                this.validatePaymentLink = null
                this.subscriptionFailed = false
                this.subscriptionProcessing = false

                if (!success) {
                    this.subscriptionFailed = true
                }
            },
            cancelValidatePayment: function () {
                const self = this
                const registerId = this.registerSuccessData ? this.registerSuccessData.id : null
                const subscriptionId = this.registerSuccessData ? this.registerSuccessData.subscriptionId : null

                self.refreshPaymentDesign(false)

                if (!subscriptionId) {
                    return self.registrationFailed(registerId)
                }

                Api.cancelSubscription(subscriptionId, function (response) {
                    if (response.success) {
                        self.registrationFailed(registerId)
                    } else {
                        self.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
            selectPlan: function (step, plan) {
                step[this.planKey] = plan[this.planKey]
                this.nextStep()
            },
            changeTermsValue: function () {
                this.termsValue = !this.termsValue
            },
            finish: function () {
                this.closeAppView()
            },
            closeAppView: function () {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    event: 'close'
                }))
            },
            sendEventToApp: function (event, data) {
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        event: event,
                        data: data
                    }))
                }
            },
            newClient: function (data) {
                const self = this
                Api.newClient(data, function (response) {
                    if (response.success) {
                        window.userLoginAutomatic = JSON.stringify({
                            email: data.email,
                            password: data.password
                        })
                        self.registrationSuccess(true)
                    } else {
                        self.registrationFailed(null, response.message)
                    }
                })
            },
            openValidatePayment: function () {
                if (window.appReceiveLink) {
                    document.getElementById('link-view').setAttribute(
                        'data', this.validatePaymentLink
                    )
                    document.getElementById('link-view').click()
                } else {
                    window.open(this.validatePaymentLink)
                    this.validatePaymentLink = null
                }

                const obj = this.config.subscription_check_success
                if (obj && obj.interval_time && obj.limit_time) {
                    this.subscriptionProcessing = true
                }
            },
            showInfo: function (info) {
                this.$alert(
                    window.strings[info] ? window.strings[info] : info,
                    '',
                    'info',
                    Utils.getAlertOptions()
                )
            },
            handleStepRegisterButton: function () {
                const self = this

                if (this.registerCreated) {
                    return false
                }

                if (!this.processing) {
                    this.processing = true
                    this.$isLoading(true)
                    const registerSrc = this.getRegisterData()
                    const currentStep = this.config.steps[this.stepIndex]

                    if (currentStep.registerButton.paymSubStatus) {
                        registerSrc.registerData.paym_sub_status = currentStep.registerButton.paymSubStatus
                    }

                    this.callRegisterService({
                        registerData: registerSrc.registerData,
                        paymentDisabledCallback: function () {
                            const newStepIndex = self.config.steps.findIndex(function (st) {
                                return st.id === currentStep.registerButton.nextStepId
                            })
                            self.initialized = false
                            self.stepIndex = newStepIndex
                            self.refreshPage()
                            self.$isLoading(false)
                        }
                    })
                }
            },
            openLinkUrl: function (url) {
                if (window.appReceiveLink) {
                    document.getElementById('link-view').setAttribute('data', url)
                    document.getElementById('link-view').click()
                } else {
                    window.open(url)
                }
            },
            openPaymentLink: function (url) {
                if (!window.openedByApp) {
                    sessionStorage.setItem('register-cache', JSON.stringify({
                        steps: this.config.steps,
                        stepIndex: this.stepIndex,
                        vivaWalletPackSelected: this.vivaWalletPackSelected,
                        promotionalCode: this.promotionalCode,
                        registerId: this.registerSuccessData ? this.registerSuccessData.id : null
                    }))
                }
                window.location.href = url
            },
            registerWithSeller: function () {
                const self = this
                const registerData = this.register(true)
                this.$isLoading(true)
                this.callRegisterService({
                    registerData: registerData,
                    paymentDisabledCallback: function () {
                        self.handleRegisterSuccess(function () {
                            Api.refreshHotmartConnections(function () { })
                            self.$isLoading(false)
                            self.nextStep({
                                finish: true
                            })
                        })
                    }
                })
            },
            openHotmartPlansStep: function () {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]
                this.promotionalCode = null
                if (currentStep.promotionalCode) {
                    this.$prompt(
                        currentStep.promotionalCodeMessage ? currentStep.promotionalCodeMessage : this.str['do_you_have_promotional_code'],
                        '',
                        '',
                        '',
                        Utils.getAlertOptions()
                    ).then(text => {
                        if (text) {
                            self.$isLoading(true)
                            Api.getHotmartSubscriptionPlans({
                                code: text
                            }, function (response) {
                                if (response.success) {
                                    if (response.data && response.data[0]) {
                                        if (response.data[0].type === self.manualRegistersType) {
                                            self.$isLoading(false)
                                            self.promotionalCode = text
                                            self.nextStep({
                                                nextStepId: 'proof'
                                            })
                                            return true
                                        }
                                        if (response.data[0].type === self.manualReturnRegistersType) {
                                            self.$isLoading(false)
                                            self.promotionalCode = text
                                            self.nextStep({
                                                nextStepId: 'proof'
                                            })
                                            return true
                                        }
                                        if (response.data[0].type === self.subscriptionReturnRegistersType) {
                                            self.$isLoading(false)
                                            self.promotionalCode = text
                                            if (response.data[0].aux_id) {
                                                self.selectHotmartPlan({
                                                    url: response.data[0].aux_id
                                                })
                                            }
                                            return true
                                        }
                                        if (response.data[0].aux_id) {
                                            self.promotionalCode = text
                                            self.selectHotmartPlan({
                                                url: response.data[0].aux_id
                                            })
                                            return true
                                        }
                                        self.$isLoading(false)
                                        self.$alert(
                                            self.str['common_error'],
                                            '',
                                            'warning',
                                            Utils.getAlertOptions()
                                        )
                                    } else {
                                        self.$isLoading(false)
                                        self.$alert(
                                            response.message,
                                            '',
                                            'warning',
                                            Utils.getAlertOptions()
                                        )
                                    }
                                } else {
                                    self.$isLoading(false)
                                    self.$alert(
                                        response.message,
                                        '',
                                        'warning',
                                        Utils.getAlertOptions()
                                    )
                                }
                            })
                        }
                    }).catch(() => { })
                }
            },
            selectHotmartPlan: function (item) {
                const self = this
                const registerData = this.register(true)
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (this.config.steps[i].id === 'subscription_hotmart') {
                        const emailParameter = registerData && registerData.email ? '&email=' + registerData.email : ''
                        const nameParameter = registerData && registerData.name ? '&name=' + registerData.name : ''
                        this.config.steps[i].url = item.url + emailParameter + nameParameter
                        break
                    }
                }
                if (this.promotionalCode) {
                    registerData.promo_code = this.promotionalCode
                }
                this.$isLoading(true)
                this.callRegisterService({
                    registerData: registerData,
                    paymentDisabledCallback: function () {
                        self.handleRegisterSuccess(function () {
                            self.nextStep()
                            self.handleSubscriptionStatus()
                            self.$isLoading(false)
                        })
                    }
                })
            },
            openStripePlansStep: function () {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]
                this.promotionalCode = null
                if ((window.planPreSelected || window.planPreSelected === 0) && currentStep.buttons && currentStep.buttons[window.planPreSelected]) {
                    this.isProcessing = true
                    this.selectStripePlan(currentStep.buttons[window.planPreSelected])
                    return true
                }
                if (currentStep.promotionalCode) {
                    this.$prompt(
                        currentStep.promotionalCodeMessage ? currentStep.promotionalCodeMessage : this.str['do_you_have_promotional_code'],
                        '',
                        '',
                        '',
                        Utils.getAlertOptions()
                    ).then(text => {
                        if (text) {
                            self.$isLoading(true)
                            Api.getSubscriptionPlans({
                                code: text,
                                currency: self.currency
                            }, function (response) {
                                if (response.success) {
                                    if (response.data && response.data[0]) {
                                        if (response.data[0].aux_id) {
                                            self.promotionalCode = text
                                            self.selectStripePlan({
                                                url: response.data[0].aux_id
                                            })
                                        } else {
                                            self.$isLoading(false)
                                            self.$alert(
                                                self.str['common_error'],
                                                '',
                                                'warning',
                                                Utils.getAlertOptions()
                                            )
                                        }
                                    } else {
                                        self.$isLoading(false)
                                        self.$alert(
                                            response.message,
                                            '',
                                            'warning',
                                            Utils.getAlertOptions()
                                        )
                                    }
                                } else {
                                    self.$isLoading(false)
                                    self.$alert(
                                        response.message,
                                        '',
                                        'warning',
                                        Utils.getAlertOptions()
                                    )
                                }
                            })
                        }
                    }).catch(() => { })
                }
            },
            selectStripePlan: function (item) {
                const self = this
                const registerData = this.register(true)
                const emailParameter = registerData && registerData.email ? '?prefilled_email=' + registerData.email : ''
                const url = item.url + emailParameter
                if (this.promotionalCode) {
                    registerData.promo_code = this.promotionalCode
                }
                if (item.id) {
                    registerData.pack_id = item.id
                }
                this.$isLoading(true)
                this.callRegisterService({
                    registerData: registerData,
                    paymentDisabledCallback: function () {
                        self.isProcessing = true
                        self.handleRegisterSuccess(function () {
                            self.sendEventToApp('start-payment', self.registerSuccessData)
                            self.sendEventToApp('register-steps', JSON.stringify({
                                steps: self.config.steps,
                                stepIndex: self.stepIndex
                            }))
                            setTimeout(function () {
                                self.$isLoading(false)
                                self.openPaymentLink(url)
                            })
                        })
                    }
                })
            },
            handleSubscriptionStatus: function () {
                const self = this

                try {
                    const currentStep = this.config.steps[this.stepIndex]
                    const obj = currentStep.subscription_check_success
                    const registerId = this.registerSuccessData ? this.registerSuccessData.id : null
                    const paymentStatusSuccess = [4]
                    const paymentStatusFailed = [2, 6]
                    let timerValue = 0
                    let processing = false
                    let timeoutPromise = false

                    if (obj && obj.interval_time && obj.limit_time) {
                        callProcessPayment()
                    }

                    function callProcessPayment() {
                        timerValue += obj.interval_time
                        if (!processing) {
                            processing = true
                            checkPaymentStatus(function (success) {
                                if (success === true) {
                                    self.nextStep({
                                        finish: true
                                    })
                                    if (obj.validate_register) {
                                        self.sendEventToApp('register-data', self.registerSuccessData)
                                        self.validateRegister({
                                            id: registerId
                                        })
                                    }
                                    return true
                                }
                                if (success === false) {
                                    self.registrationFailed(null, window.strings[obj.subscription_failed_message] ? window.strings[obj.subscription_failed_message] : obj.subscription_failed_message)
                                    return true
                                }
                                if (timerValue >= obj.limit_time) {
                                    self.registrationFailed(null, window.strings[obj.subscription_expired_message] ? window.strings[obj.subscription_expired_message] : obj.subscription_expired_message)
                                    return true
                                }
                                processing = false
                                startProcessPaymentPromise()
                            })
                        }
                    }

                    function startProcessPaymentPromise() {
                        clearTimeout(timeoutPromise)
                        timeoutPromise = setTimeout(function () {
                            callProcessPayment()
                        }, obj.interval_time)
                    }

                    function checkPaymentStatus(callback) {
                        Api.getRegister(registerId, function (response) {
                            if (response.success && response.data[0]) {
                                if (paymentStatusSuccess.indexOf(response.data[0].paym_sub_status) > -1) {
                                    return callback(true)
                                }
                                if (paymentStatusFailed.indexOf(response.data[0].paym_sub_status) > -1) {
                                    return callback(false)
                                }
                                callback(null)
                            } else {
                                callback(null)
                            }
                        })
                    }
                } catch { }
            },
            selectVivaWalletPackCategory: function (item) {
                const self = this
                this.$isLoading(true)
                this.getPacks({
                    category: item.id,
                    callback: function (packs) {
                        self.$isLoading(false)
                        for (let r = self.config.steps.length - 1; r > -1; r--) {
                            if (self.config.steps[r].id === 'payments_packs_category') {
                                self.config.steps[r].buttons = packs
                            }
                        }
                        self.nextStep()
                    }
                })
            },
            selectVivaWalletPack: function (item) {
                const data = JSON.parse(JSON.stringify(item))
                this.vivaWalletPackSelected = data
                if (data.allow_recurring && (data.allow_one_time_payments || data.allow_installments)) {
                    return this.nextStep()
                }
                data.allow_recurring = !data.allow_one_time_payments ? true : false
                this.selectVivaWalletPlan(data)
            },
            selectVivaWalletPackMode: function (item) {
                if (item.allow_recurring) {
                    this.vivaWalletPackSelected.allow_recurring = true
                    this.vivaWalletPackSelected.allow_one_time_payments = false
                } else {
                    this.vivaWalletPackSelected.allow_recurring = false
                }
                this.selectVivaWalletPlan(this.vivaWalletPackSelected)
            },
            selectVivaWalletPlan: function (item) {
                const self = this
                const registerData = this.register(true)
                if (this.promotionalCode) {
                    registerData.promo_code = this.promotionalCode
                }
                if (item.id) {
                    registerData.pack_id = item.id
                }
                this.$isLoading(true)
                this.callRegisterService({
                    registerData: registerData,
                    paymentDisabledCallback: function () {
                        if (self.registerSuccessData) {
                            if (item.amount === 0) {
                                return self.sendPaymentPromoFree()
                            }
                            self.isProcessing = true
                            Api.createOrderVW({
                                amount: item.amount + (item.signup_fee > 0 ? item.signup_fee : 0),
                                customerTrns: item.text + (item.signup_fee > 0 && self.config.signup_fee ? self.config.signup_fee : ''),
                                customer: {
                                    email: self.registerSuccessData.email,
                                    fullName: self.registerSuccessData.name,
                                    phone: self.registerSuccessData.mobile_phone
                                },
                                allowRecurring: item.allow_recurring,
                                allow_one_time_payments: item.allow_one_time_payments,
                                allow_installments: item.allow_installments,
                                tags: [
                                    JSON.stringify({
                                        paym_subt: item.paym_subt,
                                        allow_recurring: item.allow_recurring,
                                        register_id: self.registerSuccessData.id
                                    })
                                ]
                            }, function (response) {
                                if (response.success && response.data && response.data.order_url) {
                                    self.handleRegisterSuccess(function () {
                                        self.sendEventToApp('start-payment', self.registerSuccessData)
                                        self.sendEventToApp('register-steps', JSON.stringify({
                                            steps: self.config.steps,
                                            stepIndex: self.stepIndex
                                        }))
                                        setTimeout(function () {
                                            self.$isLoading(false)
                                            self.openPaymentLink(response.data.order_url)
                                        })
                                    })
                                } else {
                                    self.isProcessing = false
                                    self.$isLoading(false)
                                    self.registrationFailed(self.registerSuccessData.id, response.message)
                                }
                            })
                        } else {
                            self.$isLoading(false)
                            self.registrationFailed(null, window.strings['common_error'])
                        }
                    }
                })
            },
            selectButtonOption: function (item, value) {
                item.value = value
            },
            changeSlide: function (item, value) {
                item.value = item.items[value.currentSlide.index].value
            },
            closeSelect: function (id) {
                const select = this.$refs['component-multiselect-' + id] ? this.$refs['component-multiselect-' + id][0] : null
                if (select) {
                    select.blur()
                }
            },
            changeDatepickerInline: function (item) {
                item.value = this.datepickerInline.year + '-' + this.datepickerInline.month + '-' + this.datepickerInline.day
            },
            getDays: function () {
                const lastDay = new Date(this.datepickerInline.year, this.datepickerInline.month, 0).getDate()
                return Array.from({ length: lastDay }, (_, index) => {
                    const monthNumber = index + 1;
                    const monthValue = monthNumber < 10 ? `0${monthNumber}` : monthNumber.toString();
                    return { name: monthNumber, value: monthValue };
                })
            },
            getMonths: function () {
                return [
                    { name: 'jan', value: '01' },
                    { name: 'fev', value: '02' },
                    { name: 'mar', value: '03' },
                    { name: 'abr', value: '04' },
                    { name: 'mai', value: '05' },
                    { name: 'jun', value: '06' },
                    { name: 'jul', value: '07' },
                    { name: 'ago', value: '08' },
                    { name: 'set', value: '09' },
                    { name: 'out', value: '10' },
                    { name: 'nov', value: '11' },
                    { name: 'dez', value: '12' }
                ]
            },
            getYears: function () {
                const currYear = new Date().getFullYear()
                const lastYear = 1920
                return Array.from({ length: currYear - lastYear + 1 }, (_, index) => lastYear + index).reverse()
            },
            openSelectSearch: function (item) {
                const list = []
                let excludeItems = []
                if (item.excludeItems) {
                    const step = this.config.steps[this.stepIndex]
                    if (step && step.fields) {
                        step.fields.forEach(function (fd) {
                            if (item.excludeItems.indexOf(fd.id) > -1) {
                                if (fd.value) {
                                    if (fd.type === 'multiselect' || fd.type === 'multiselect_search') {
                                        excludeItems = excludeItems.concat(fd.value)
                                    } else {
                                        excludeItems.push(fd.value)
                                    }
                                }
                            }
                        })
                    }
                    excludeItems = [...new Set(excludeItems)]
                }
                let filterFieldToCompareValue = null
                for (let i = 0; i < item.items.length; i++) {
                    const clone = item.items[i]
                    clone.active = false
                    if (item.request && item.request.filter && item.request.filter.values && item.request.filter.values[clone.value]) {
                        if (!filterFieldToCompareValue) {
                            filterFieldToCompareValue = this.getFieldValue(item.request.filter.fieldToCompare)
                        }
                        if (filterFieldToCompareValue && item.request.filter.values[clone.value].indexOf(filterFieldToCompareValue) > -1) {
                            continue
                        }
                    }
                    if ((item.type !== 'multiselect_search' && item.value === clone.value) ||
                        (item.type === 'multiselect_search' && item.value.indexOf(clone.value) > -1)
                    ) {
                        clone.active = true
                    }
                    clone.disabled = excludeItems.indexOf(clone.value) > -1 ? true : false
                    list.push(clone)
                }
                this.selectSearchItemsSearch = ''
                this.selectSearchItems = list
                this.updateMultiselectSearchField(item, {
                    opened: true
                })
            },
            getFieldValue: function (key) {
                for (let s = 0; s < this.config.steps.length; s++) {
                    for (let f = 0; f < this.config.steps[s].fields.length; f++) {
                        if (this.config.steps[s].fields[f].id === key) {
                            return this.config.steps[s].fields[f].value
                        }
                    }
                }
                return null
            },
            closeSelectSearch: function (item) {
                this.updateMultiselectSearchField(item, {
                    opened: false
                })
                this.selectSearchItemsSearch = ''
                this.selectSearchItems = []
            },
            selectItemSelectSearch: function (field, item) {
                if (field.type === 'multiselect_search') {
                    const index = this.selectSearchItems.findIndex(function (it) {
                        return it.value === item.value
                    })
                    if (index > -1) {
                        this.selectSearchItems[index].active = !this.selectSearchItems[index].active
                        this.$set(this.selectSearchItems, index, this.selectSearchItems[index])
                    }
                } else {
                    for (let i = 0; i < this.selectSearchItems.length; i++) {
                        if (this.selectSearchItems[i].active && this.selectSearchItems[i].value !== item.value) {
                            this.selectSearchItems[i].active = false
                            this.$set(this.selectSearchItems, i, this.selectSearchItems[i])
                        }
                        if (this.selectSearchItems[i].value === item.value) {
                            this.selectSearchItems[i].active = true
                            this.$set(this.selectSearchItems, i, this.selectSearchItems[i])
                        }
                    }
                    this.confirmSelectSearch(field)
                }
            },
            confirmSelectSearch: function (item) {
                const selectedItems = []
                this.selectSearchItems.forEach(function (it) {
                    if (it.active) {
                        selectedItems.push(it.value)
                    }
                })
                this.updateMultiselectSearchField(item, {
                    opened: false,
                    value: item.type === 'multiselect_search' ? selectedItems : selectedItems[0]
                })
            },
            updateMultiselectSearchField: function (item, keys) {
                const index = this.config.steps[this.stepIndex].fields.findIndex(function (it) {
                    return it.id === item.id
                })
                if (index > -1) {
                    for (const key in keys) {
                        this.config.steps[this.stepIndex].fields[index][key] = keys[key]
                    }
                    this.$set(this.config.steps[this.stepIndex].fields, index, this.config.steps[this.stepIndex].fields[index])
                }
            },
            openSelectIndicativeSearch: function (item) {
                const list = []
                for (let i = 0; i < this.mobilePhonePrefixsList.length; i++) {
                    const clone = this.mobilePhonePrefixsList[i]
                    if (this.mobilePhoneIndicative === clone.value) {
                        clone.active = true
                    }
                    list.push(clone)
                }
                this.selectSearchItemsSearch = ''
                this.selectSearchItems = list
                this.updateMultiselectSearchField(item, {
                    opened: true
                })
            },
            selectItemSelectIndicativeSearch: function (field, item) {
                for (let i = 0; i < this.selectSearchItems.length; i++) {
                    if (this.selectSearchItems[i].active && this.selectSearchItems[i].value !== item.value) {
                        this.selectSearchItems[i].active = false
                        this.$set(this.selectSearchItems, i, this.selectSearchItems[i])
                    }
                    if (this.selectSearchItems[i].value === item.value) {
                        this.selectSearchItems[i].active = true
                        this.$set(this.selectSearchItems, i, this.selectSearchItems[i])
                    }
                }
                this.confirmSelectIndicativeSearch(field)
            },
            confirmSelectIndicativeSearch: function (item) {
                const selectedItems = []
                this.selectSearchItems.forEach(function (it) {
                    if (it.active) {
                        selectedItems.push(it.value)
                    }
                })
                this.updateMultiselectSearchField(item, {
                    opened: false
                })
                this.mobilePhoneIndicative = selectedItems[0]
            },
            getFieldItem: function (field) {
                const item = field.items.find(function (i) {
                    return i.value === field.value
                })
                if (item) {
                    return item
                }
                return {
                    label: '',
                    labelImage: '',
                }
            },
            copyTextToClipboard: function (event, text) {
                try {
                    if (navigator && navigator.clipboard) {
                        const textarea = document.createElement('textarea')
                        textarea.value = text
                        document.body.appendChild(textarea)
                        textarea.select()
                        document.execCommand('copy')
                        document.body.removeChild(textarea)
                        if (event) {
                            const element = event.currentTarget
                            if (element) {
                                element.style.color = '#888'
                                setTimeout(function () {
                                    element.style.color = ''
                                }, 300)
                            }
                        }
                    }
                } catch { }
            },
            handlePageShow: function (event) {
                if (!this.openedByApp && event.persisted) {
                    location.reload()
                }
            },
        },
        mounted: function () {
            if (!this.openedByApp) {
                window.addEventListener('pageshow', this.handlePageShow)
            }
        },
        beforeDestroy: function () {
            if (!this.openedByApp) {
                window.removeEventListener('pageshow', this.handlePageShow)
            }
        },
    }
</script>